// 自动生成，请勿手动修改
import type { Skill } from '../core/types';

export const SKILLS: Skill[] = [
  {
    id: '1',
    name: '猛烈撞击',
    power: 65,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '2',
    name: '闪光',
    power: 60,
    type: '光',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '3',
    name: '防御',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦减伤70%，应对攻击。',
  },
  {
    id: '4',
    name: '魔法增效',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 0,
    effect: '✦自己获得魔攻+70%。',
  },
  {
    id: '5',
    name: '光球',
    power: 80,
    type: '光',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '6',
    name: '火焰箭',
    power: 80,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '7',
    name: '力量增效',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦自己获得物攻+100%。',
  },
  {
    id: '8',
    name: '棘突',
    power: 100,
    type: '草',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '9',
    name: '潮涌',
    power: 80,
    type: '水',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '10',
    name: '超导',
    power: 95,
    type: '电',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，迸发：本技能能耗-1。',
  },
  {
    id: '11',
    name: '闪光冲击',
    power: 100,
    type: '光',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '12',
    name: '漫反射',
    power: 0,
    type: '光',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦每种系别中的至多1个技能，威力+35。',
  },
  {
    id: '13',
    name: '冰爪',
    power: 80,
    type: '冰',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '14',
    name: '热砂',
    power: 80,
    type: '地',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '15',
    name: '念力膨胀',
    power: 80,
    type: '幻',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '16',
    name: '放晴',
    power: 0,
    type: '光',
    category: 'status',
    accuracy: 100,
    energyCost: 0,
    effect: '✦光系技能威力永久+50%，应对防御：改为永久+100%。',
  },
  {
    id: '17',
    name: '过曝',
    power: 60,
    type: '光',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，每使用过1个其他系别技能，本技能威力永久+30。',
  },
  {
    id: '18',
    name: '光刃',
    power: 120,
    type: '光',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '19',
    name: '折射',
    power: 50,
    type: '光',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成魔伤，携带其他系别技能会给本技能带来不同效果。',
  },
  {
    id: '20',
    name: '星星撞击',
    power: 90,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '21',
    name: '恶能量',
    power: 60,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '22',
    name: '升龙咆哮',
    power: 200,
    type: '龙',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦蓄力，对敌方造成魔法伤害。',
  },
  {
    id: '23',
    name: '球状闪电',
    power: 60,
    type: '电',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '24',
    name: '缠丝劲',
    power: 25,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦造成物伤，2连击。',
  },
  {
    id: '25',
    name: '火焰冲锋',
    power: 60,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '26',
    name: '幻象',
    power: 60,
    type: '幽',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '27',
    name: '花香',
    power: 60,
    type: '草',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '28',
    name: '冷风',
    power: 60,
    type: '冰',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '29',
    name: '噬心',
    power: 60,
    type: '虫',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '30',
    name: '折线冲击',
    power: 80,
    type: '光',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '31',
    name: '离子震荡',
    power: 90,
    type: '机械',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，本技能位于3号位时威力+40，传动1。',
  },
  {
    id: '32',
    name: '魅惑',
    power: 60,
    type: '萌',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '33',
    name: '星云漩涡',
    power: 60,
    type: '幻',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '34',
    name: '扬沙',
    power: 60,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '35',
    name: '溃烂触碰',
    power: 60,
    type: '毒',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '36',
    name: '泡沫',
    power: 60,
    type: '水',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '37',
    name: '鹰爪',
    power: 60,
    type: '翼',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '38',
    name: '借用',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 0,
    effect: '✦每回合随机变成己方队伍中其他精灵的技能。',
  },
  {
    id: '39',
    name: '坍缩',
    power: 85,
    type: '幻',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，若击败敌方，自己获得魔攻+70%。',
  },
  {
    id: '40',
    name: '天洪',
    power: 150,
    type: '水',
    category: 'special',
    accuracy: 100,
    energyCost: 7,
    effect: '✦造成魔伤，应对状态：本技能能耗永久-6。',
  },
  {
    id: '41',
    name: '寒风吹',
    power: 70,
    type: '冰',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，敌方获得魔防-50%。',
  },
  {
    id: '42',
    name: '怒火',
    power: 0,
    type: '火',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦自己获得双攻+120%和双防-40%。',
  },
  {
    id: '43',
    name: '抽枝',
    power: 90,
    type: '草',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成物伤，应对状态：自己回复50%生命和5能量。',
  },
  {
    id: '44',
    name: '有效预防',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦减伤50%，应对攻击：下一次行动获得先手+1。',
  },
  {
    id: '45',
    name: '气泡',
    power: 100,
    type: '水',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '46',
    name: '氧输送',
    power: 0,
    type: '草',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦自己回复4能量，并获得魔攻+70%。',
  },
  {
    id: '47',
    name: '润泽',
    power: 0,
    type: '水',
    category: 'status',
    accuracy: 100,
    energyCost: 7,
    effect: '✦自己获得魔攻+190%。',
  },
  {
    id: '48',
    name: '炎打',
    power: 95,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成高额魔法伤害，自己获得物防-40%。',
  },
  {
    id: '49',
    name: '电弧',
    power: 80,
    type: '电',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，迸发：本次技能威力+40。',
  },
  {
    id: '50',
    name: '藤绞',
    power: 80,
    type: '草',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成物伤，自己回复5能量。',
  },
  {
    id: '51',
    name: '跺地',
    power: 80,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '52',
    name: '闪燃',
    power: 40,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦造成物伤，应对状态：本次技能威力变为4倍。',
  },
  {
    id: '53',
    name: '抓挠',
    power: 35,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '✦造成物伤，自己回复1能量。',
  },
  {
    id: '54',
    name: '休息回复',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦自己回复30%生命。',
  },
  {
    id: '55',
    name: '扫尾',
    power: 90,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '56',
    name: '徒长',
    power: 0,
    type: '草',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦自己回复10能量。',
  },
  {
    id: '57',
    name: '叶绿光束',
    power: 120,
    type: '草',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '58',
    name: '酶浓度调整',
    power: 0,
    type: '草',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦减伤80%，应对攻击：自己回复20%生命。',
  },
  {
    id: '59',
    name: '筛管奔流',
    power: 80,
    type: '草',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，自己生命大于80%时，本次技能威力+75。',
  },
  {
    id: '60',
    name: '盛开',
    power: 0,
    type: '草',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦自己获得全技能威力+30，应对防御：改为威力+60。',
  },
  {
    id: '61',
    name: '孢子',
    power: 0,
    type: '草',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦敌方获得1层寄生。',
  },
  {
    id: '62',
    name: '仙人掌刺击',
    power: 150,
    type: '草',
    category: 'physical',
    accuracy: 100,
    energyCost: 6,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '63',
    name: '丰饶',
    power: 0,
    type: '草',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦自己获得物攻和魔攻+140%。',
  },
  {
    id: '64',
    name: '光合作用',
    power: 0,
    type: '草',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '✦自己获得1层光合印记。',
  },
  {
    id: '65',
    name: '光能聚集',
    power: 100,
    type: '草',
    category: 'special',
    accuracy: 100,
    energyCost: 7,
    effect: '✦造成魔伤，每次使用其他草系技能后，本技能威力永久+60。',
  },
  {
    id: '66',
    name: '贪婪',
    power: 0,
    type: '恶',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦自己获得100%吸血。',
  },
  {
    id: '67',
    name: '麻痹',
    power: 0,
    type: '电',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦敌方先手-1，应对防御：额外使敌方获得双攻-70%。',
  },
  {
    id: '68',
    name: '化劲',
    power: 0,
    type: '武',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦自己获得全技能威力+40。',
  },
  {
    id: '69',
    name: '引燃',
    power: 0,
    type: '火',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦敌方获得10层灼烧。',
  },
  {
    id: '70',
    name: '勾魂',
    power: 0,
    type: '幽',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦偷取敌方3能量。',
  },
  {
    id: '71',
    name: '荆棘爪',
    power: 80,
    type: '草',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '72',
    name: '霜降',
    power: 0,
    type: '冰',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦敌方获得4层冻结。',
  },
  {
    id: '73',
    name: '假寐',
    power: 0,
    type: '虫',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦自己回复2能量，己方队伍获得1次奉献：能耗-2。',
  },
  {
    id: '74',
    name: '虹光冲击',
    power: 100,
    type: '光',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '75',
    name: '啮合传递',
    power: 0,
    type: '机械',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦自己获得速度+80，本技能位于1号或3号位时额外获得物攻+60%，传动1。',
  },
  {
    id: '76',
    name: '甜心续航',
    power: 0,
    type: '萌',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦自己和敌方获得萌化：回复40%生命和4能量。',
  },
  {
    id: '77',
    name: '超维投射',
    power: 0,
    type: '幻',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '✦敌方获得4层星陨印记。',
  },
  {
    id: '78',
    name: '泥浆铠甲',
    power: 0,
    type: '地',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦自己获得物攻和物防+60%，应对防御：额外使自己的增益翻倍。',
  },
  {
    id: '79',
    name: '蓄水',
    power: 0,
    type: '水',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦下次使用的技能能耗-6。',
  },
  {
    id: '80',
    name: '羽化加速',
    power: 0,
    type: '翼',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦自己获得全技能威力+20，迅捷。',
  },
  {
    id: '81',
    name: '剧毒',
    power: 0,
    type: '毒',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦敌方获得3层中毒，应对防御：改为获得8层。',
  },
  {
    id: '82',
    name: '天光',
    power: 95,
    type: '光',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，本技能系别和天气系别相同。',
  },
  {
    id: '83',
    name: '应激反应',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦自己回复25%生命，应对防御：改为回复50%生命。',
  },
  {
    id: '84',
    name: '摇篮曲',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 5,
    effect: '✦敌方获得全技能能耗+3，应对防御：额外造成打断，且敌方下回合获得眩晕。',
  },
  {
    id: '85',
    name: '晒太阳',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦驱散敌方所有增益。',
  },
  {
    id: '86',
    name: '毒孢子',
    power: 0,
    type: '毒',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦敌方获得5层中毒。',
  },
  {
    id: '87',
    name: '毒沼',
    power: 80,
    type: '毒',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '88',
    name: '瘴气喷射',
    power: 100,
    type: '毒',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '89',
    name: '移花接木',
    power: 0,
    type: '草',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦自己回复15%生命，随后脱离。',
  },
  {
    id: '90',
    name: '精神扰乱',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 0,
    effect: '✦敌方获得全技能能耗+1，应对防御：改为能耗+3。',
  },
  {
    id: '91',
    name: '纤维化',
    power: 0,
    type: '草',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤80%，应对攻击：自己获得物防+70%。',
  },
  {
    id: '92',
    name: '腐化',
    power: 0,
    type: '毒',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦敌方每有1层中毒效果，敌方获得双攻-30%。',
  },
  {
    id: '93',
    name: '腐蚀酸液',
    power: 35,
    type: '毒',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成魔伤，敌方获得2层中毒。',
  },
  {
    id: '94',
    name: '透射',
    power: 60,
    type: '光',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '95',
    name: '重击',
    power: 110,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成物伤，每次使用后，本技能能耗永久+1。',
  },
  {
    id: '96',
    name: '火苗',
    power: 30,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '✦造成物伤，自己回复1能量。',
  },
  {
    id: '97',
    name: '火焰切割',
    power: 100,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '98',
    name: '吹火',
    power: 50,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦造成物伤，每次使用后，本技能威力永久+20。',
  },
  {
    id: '99',
    name: '持续高温',
    power: 70,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成魔伤，应对状态：下次攻击技能威力翻倍。',
  },
  {
    id: '100',
    name: '火云车',
    power: 140,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 5,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '101',
    name: '热身',
    power: 0,
    type: '火',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦下一次攻击时，技能威力翻倍，应对防御：改为威力变为4倍。',
  },
  {
    id: '102',
    name: '山火',
    power: 15,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，每使用1次其他火系技能，本技能威力永久翻倍。',
  },
  {
    id: '103',
    name: '灵媒',
    power: 100,
    type: '幽',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '104',
    name: '械斗',
    power: 45,
    type: '机械',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦造成物伤，本技能位于1号位时威力+60，传动1。',
  },
  {
    id: '105',
    name: '碰爪',
    power: 60,
    type: '萌',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '106',
    name: '乘风',
    power: 0,
    type: '翼',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦自己获得速度+120。',
  },
  {
    id: '107',
    name: '力量吞噬',
    power: 0,
    type: '恶',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '✦敌方获得全技能威力-20，自己获得全技能威力+20。',
  },
  {
    id: '108',
    name: '压扁',
    power: 155,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 5,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '109',
    name: '复写',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 0,
    effect: '✦每回合随机变成自己未携带的技能，且该技能能耗-2。',
  },
  {
    id: '110',
    name: '扇风',
    power: 75,
    type: '翼',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，若先于敌方攻击，本次技能威力+50%。',
  },
  {
    id: '111',
    name: '暗突袭',
    power: 70,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成物伤，吸血50%，应对状态：本次技能威力翻倍。',
  },
  {
    id: '112',
    name: '诋毁',
    power: 80,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '113',
    name: '锐利眼神',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦敌方获得物防和魔防-120%。',
  },
  {
    id: '114',
    name: '阻断',
    power: 80,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成魔伤，应对状态：额外打断被应对技能。',
  },
  {
    id: '115',
    name: '风矢',
    power: 80,
    type: '翼',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '116',
    name: '龙之利爪',
    power: 130,
    type: '龙',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦蓄力，造成物伤并吸血50%。',
  },
  {
    id: '117',
    name: '龙卷风',
    power: 70,
    type: '翼',
    category: 'physical',
    accuracy: 100,
    energyCost: 5,
    effect: '✦造成物伤，迅捷，应对状态：本次技能威力变为1.5倍。',
  },
  {
    id: '118',
    name: '拍击',
    power: 65,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '119',
    name: '甩水',
    power: 30,
    type: '水',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '✦造成魔伤，自己回复1能量。',
  },
  {
    id: '120',
    name: '水泡盾',
    power: 0,
    type: '水',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤80%，应对攻击：自己获得魔攻+70%。',
  },
  {
    id: '121',
    name: '水炮',
    power: 110,
    type: '水',
    category: 'special',
    accuracy: 100,
    energyCost: 5,
    effect: '✦造成魔伤，每次使用后，本技能能耗永久-1。',
  },
  {
    id: '122',
    name: '洗礼',
    power: 0,
    type: '水',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦驱散自己的减益，并获得全技能能耗-1。',
  },
  {
    id: '123',
    name: '泡沫幻影',
    power: 0,
    type: '水',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤80%，应对攻击：自己脱离。',
  },
  {
    id: '124',
    name: '涌泉',
    power: 60,
    type: '水',
    category: 'special',
    accuracy: 100,
    energyCost: 6,
    effect: '✦造成魔伤，本技能能耗每-1，威力+10。',
  },
  {
    id: '125',
    name: '落雨',
    power: 0,
    type: '水',
    category: 'status',
    accuracy: 100,
    energyCost: 5,
    effect: '✦将天气改为雨天，持续8回合。',
  },
  {
    id: '126',
    name: '潮汐',
    power: 0,
    type: '水',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '✦减伤60%，应对攻击：自己获得1层湿润印记。',
  },
  {
    id: '127',
    name: '防反',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤60%，应对攻击：自己获得物攻和魔攻+40%。',
  },
  {
    id: '128',
    name: '等价交换',
    power: 0,
    type: '恶',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦减伤90%，应对攻击：自己获得50%吸血。',
  },
  {
    id: '129',
    name: '集中',
    power: 0,
    type: '电',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤80%，应对攻击：自己回合结束返场。',
  },
  {
    id: '130',
    name: '反击拳',
    power: 25,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成物伤，2连击，若后手攻击，改为3连击。',
  },
  {
    id: '131',
    name: '火焰护盾',
    power: 0,
    type: '火',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤70%，应对攻击：敌方获得6层灼烧。',
  },
  {
    id: '132',
    name: '虚化',
    power: 0,
    type: '幽',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤80%，应对攻击：自己获得魔防+70%。',
  },
  {
    id: '133',
    name: '蜡质膜',
    power: 0,
    type: '草',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤80%，应对攻击：回复3能量。',
  },
  {
    id: '134',
    name: '雪替身',
    power: 0,
    type: '冰',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤70%，应对攻击：回复能量，回复值等于被应对技能能耗的2倍。',
  },
  {
    id: '135',
    name: '掩护',
    power: 0,
    type: '虫',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤70%，紧急脱离，应对攻击：下个入场精灵获得减伤。',
  },
  {
    id: '136',
    name: '冥想',
    power: 0,
    type: '幻',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦减伤80%，应对攻击：敌方获得2层星陨印记。',
  },
  {
    id: '137',
    name: '淤泥表皮',
    power: 0,
    type: '地',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤80%，应对攻击：敌方获得连击数-3。',
  },
  {
    id: '138',
    name: '水弹枪',
    power: 80,
    type: '水',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '139',
    name: '羽翼庇护',
    power: 0,
    type: '翼',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦减伤70%，应对攻击：自己获得连击数+3。',
  },
  {
    id: '140',
    name: '冰墙',
    power: 0,
    type: '冰',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤80%，应对攻击：敌方获得2层冻结。',
  },
  {
    id: '141',
    name: '冰天雪地',
    power: 0,
    type: '冰',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤80%，应对攻击：被应对技能能耗+3。',
  },
  {
    id: '142',
    name: '吓退',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤60%，应对攻击：敌方脱离。',
  },
  {
    id: '143',
    name: '嗜痛',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤80%，应对攻击：期间自己每次受到伤害，获得双攻+40%。',
  },
  {
    id: '144',
    name: '多维击打',
    power: 15,
    type: '幻',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成魔伤，1连击，敌方每有1层星陨印记，本次技能连击数+1。',
  },
  {
    id: '145',
    name: '水波术',
    power: 90,
    type: '水',
    category: 'special',
    accuracy: 100,
    energyCost: 6,
    effect: '✦造成魔伤，回合结束时，本技能威力永久+20。',
  },
  {
    id: '146',
    name: '突袭',
    power: 70,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成魔伤，应对状态：本次技能威力变为3倍。',
  },
  {
    id: '147',
    name: '速冻',
    power: 0,
    type: '冰',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '✦敌方获得2层减速印记。',
  },
  {
    id: '148',
    name: '魔能爆',
    power: 1,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '✦造成魔伤，使用时消耗所有能量，消耗越高，伤害越高。',
  },
  {
    id: '149',
    name: '旋转突击',
    power: 35,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，3连击。',
  },
  {
    id: '150',
    name: '咆哮',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦敌方获得物攻-130%。',
  },
  {
    id: '151',
    name: '见招拆招',
    power: 65,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成物伤，若上回合使用状态技能，本次技能威力+55。',
  },
  {
    id: '152',
    name: '伺机而动',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦下一次攻击时，技能威力+70。',
  },
  {
    id: '153',
    name: '热身运动',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦自己获得连击数+3。',
  },
  {
    id: '154',
    name: '吨位压制',
    power: 0,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，敌方体重越低，威力越高。',
  },
  {
    id: '155',
    name: '快速移动',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦自己获得速度+80，应对防御：改为速度+160。',
  },
  {
    id: '156',
    name: '三连破',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦自己获得物攻+30%，3连击。',
  },
  {
    id: '157',
    name: '主场优势',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦自己获得1层攻击印记。',
  },
  {
    id: '158',
    name: '冲撞',
    power: 135,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 7,
    effect: '✦造成物伤，回合结束时，本技能能耗永久-1。',
  },
  {
    id: '159',
    name: '提气',
    power: 0,
    type: '武',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '✦自己获得全技能威力+40，若敌方本回合更换精灵，额外获得威力+50。',
  },
  {
    id: '160',
    name: '破绽',
    power: 0,
    type: '武',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦敌方获得双防-70%，应对防御：自己额外获得物攻+70%。',
  },
  {
    id: '161',
    name: '飞羽',
    power: 0,
    type: '翼',
    category: 'status',
    accuracy: 100,
    energyCost: 0,
    effect: '✦迅捷，驱散敌方1种增益。',
  },
  {
    id: '162',
    name: '音波弹',
    power: 60,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '✦造成魔伤，1连击。',
  },
  {
    id: '163',
    name: '许愿星',
    power: 110,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '164',
    name: '蓄能轰击',
    power: 130,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 6,
    effect: '✦造成魔伤，每使用1次普通系技能，本技能能耗永久-2。',
  },
  {
    id: '165',
    name: '鼓劲',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦自己获得魔防+170%。',
  },
  {
    id: '166',
    name: '加固',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦自己获得物防+140%。',
  },
  {
    id: '167',
    name: '回旋风暴',
    power: 100,
    type: '翼',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '168',
    name: '气波',
    power: 40,
    type: '武',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '169',
    name: '翼击',
    power: 50,
    type: '翼',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，迅捷。',
  },
  {
    id: '170',
    name: '肥皂泡',
    power: 60,
    type: '水',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '171',
    name: '后发制人',
    power: 155,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物理伤害，先手-1。',
  },
  {
    id: '172',
    name: '水光冲击',
    power: 140,
    type: '水',
    category: 'special',
    accuracy: 100,
    energyCost: 5,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '173',
    name: '水环',
    power: 0,
    type: '水',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤60%，应对攻击：自己获得全技能能耗-2。',
  },
  {
    id: '174',
    name: '贯手',
    power: 80,
    type: '武',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '175',
    name: '风墙',
    power: 0,
    type: '翼',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤50%，迅捷，应对攻击。',
  },
  {
    id: '176',
    name: '叠势',
    power: 25,
    type: '武',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，2连击，每成功应对1次，本技能连击数永久+2。',
  },
  {
    id: '177',
    name: '无畏之心',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 5,
    effect: '✦减伤100%，应对攻击：减免的伤害变为回复自己生命，且本技能能耗永久+2。',
  },
  {
    id: '178',
    name: '硬门',
    power: 0,
    type: '武',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦应对攻击：打断被应对技能，并造成90威力物伤。',
  },
  {
    id: '179',
    name: '防御反击',
    power: 0,
    type: '武',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦减伤80%，应对攻击：自己获得全技能威力+40。',
  },
  {
    id: '180',
    name: '虚假破产',
    power: 0,
    type: '恶',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤80%，能量不足时，消耗5%生命代替1能量，应对攻击。',
  },
  {
    id: '181',
    name: '降灵',
    power: 0,
    type: '幽',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦敌方获得1层降灵印记。',
  },
  {
    id: '182',
    name: '撕咬',
    power: 30,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，3连击，若自己的生命低于50%，本次技能连击数+2。',
  },
  {
    id: '183',
    name: '恶作剧',
    power: 0,
    type: '幽',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦敌方失去3能量，应对防御：改为敌方失去6能量。',
  },
  {
    id: '184',
    name: '极限撕裂',
    power: 135,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成物伤，若生命高于50%，使用后自己获得双攻-50%。',
  },
  {
    id: '185',
    name: '恶意逃离',
    power: 0,
    type: '恶',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦脱离，应对防御：额外使敌方攻击技能能耗+4。',
  },
  {
    id: '186',
    name: '坟场搏击',
    power: 180,
    type: '幽',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成物伤，敌方每有1能量，本次技能威力-10%。',
  },
  {
    id: '187',
    name: '伪造账单',
    power: 0,
    type: '恶',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦若敌方本回合回复生命，改为失去2倍。先手+1。',
  },
  {
    id: '188',
    name: '富养化',
    power: 0,
    type: '草',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦为场下每个精灵回复3能量。',
  },
  {
    id: '189',
    name: '报复',
    power: 0,
    type: '幽',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤70%，应对攻击：敌方失去3能量。',
  },
  {
    id: '190',
    name: '暗箱操作',
    power: 0,
    type: '恶',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦自己获得双攻和双防-100%，应对防御：改为敌方获得双攻和双防-100%。',
  },
  {
    id: '191',
    name: '欺诈契约',
    power: 0,
    type: '恶',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦与敌方交换增益和减益。',
  },
  {
    id: '192',
    name: '聒噪',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦敌方获得全攻击技能能耗+3，持续3回合。',
  },
  {
    id: '193',
    name: '芳香诱引',
    power: 0,
    type: '草',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦自己获得连击数+3，应对防御：额外造成打断，且敌方下回合获得眩晕。',
  },
  {
    id: '194',
    name: '隐藏条款',
    power: 0,
    type: '恶',
    category: 'status',
    accuracy: 100,
    energyCost: 8,
    effect: '✦与敌方交换携带的技能。',
  },
  {
    id: '195',
    name: '啄击',
    power: 15,
    type: '翼',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '✦造成物伤，2连击。',
  },
  {
    id: '196',
    name: '先发制人',
    power: 55,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成物理伤害，先手+1。',
  },
  {
    id: '197',
    name: '闪击',
    power: 60,
    type: '翼',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成物伤，速度比敌方越高，本次技能威力越高。',
  },
  {
    id: '198',
    name: '风起',
    power: 0,
    type: '翼',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '✦自己获得1层风起印记。',
  },
  {
    id: '199',
    name: '俯冲猛击',
    power: 140,
    type: '翼',
    category: 'physical',
    accuracy: 100,
    energyCost: 5,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '200',
    name: '羽刃',
    power: 75,
    type: '翼',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成物伤，应对状态：回合结束使敌方紧急脱离。',
  },
  {
    id: '201',
    name: '以重制重',
    power: 0,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，敌方体重越高，本次技能威力越高。',
  },
  {
    id: '202',
    name: '偷袭',
    power: 85,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，应对状态：本次技能威力变为3倍。',
  },
  {
    id: '203',
    name: '冰雹',
    power: 105,
    type: '冰',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成物伤，应对状态：额外使敌方获得全技能能耗+3。',
  },
  {
    id: '204',
    name: '水刃',
    power: 115,
    type: '水',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成物伤，应对状态：本技能能耗永久-4。',
  },
  {
    id: '205',
    name: '水幕冲击',
    power: 100,
    type: '水',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '206',
    name: '疾风刺',
    power: 25,
    type: '翼',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成物伤，1连击，若先于敌方攻击，改为3连击。',
  },
  {
    id: '207',
    name: '鬼火',
    power: 30,
    type: '幽',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '✦造成魔伤，自己回复1能量。',
  },
  {
    id: '208',
    name: '种子弹',
    power: 30,
    type: '草',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '✦造成物伤，自己回复1能量。',
  },
  {
    id: '209',
    name: '汲取',
    power: 30,
    type: '草',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '✦造成魔伤，并吸血100%。',
  },
  {
    id: '210',
    name: '嘲弄',
    power: 0,
    type: '幽',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦自己获得魔攻+90%，若敌方本回合更换精灵，自己获得速度+70。',
  },
  {
    id: '211',
    name: '灵光',
    power: 25,
    type: '幽',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，3连击，若敌方本回合更换精灵，本次技能连击数翻倍。',
  },
  {
    id: '212',
    name: '惊吓盒子',
    power: 80,
    type: '幽',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，应对状态：使敌方失去6能量。',
  },
  {
    id: '213',
    name: '不可接触',
    power: 0,
    type: '毒',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦减伤50%，敌方每有1层中毒效果，本技能减伤+10%，应对攻击。',
  },
  {
    id: '214',
    name: '取念',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 0,
    effect: '✦每回合随机变成敌方任意精灵的技能，且该技能能耗-2。',
  },
  {
    id: '215',
    name: '孢子爆散',
    power: 30,
    type: '草',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，1连击，每次使用后，本技能连击数永久+2。',
  },
  {
    id: '216',
    name: '穿膛',
    power: 65,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成物伤，若敌方能量小于等于2，造成5倍伤害。',
  },
  {
    id: '217',
    name: '能量炮',
    power: 50,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，2连击。',
  },
  {
    id: '218',
    name: '血气',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤60%，应对攻击：本回合受到致命伤害时，保留1生命值。',
  },
  {
    id: '219',
    name: '连续毒针',
    power: 15,
    type: '毒',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成物伤，2连击，每次连击使敌方获得1层中毒。',
  },
  {
    id: '220',
    name: '泥巴喷射',
    power: 60,
    type: '地',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '221',
    name: '石肤术',
    power: 0,
    type: '地',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦自己获得物防+160%和魔防-60%。',
  },
  {
    id: '222',
    name: '钧势',
    power: 0,
    type: '地',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦自己获得物防+140%和速度-30。',
  },
  {
    id: '223',
    name: '落石',
    power: 55,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦造成物伤，1连击。',
  },
  {
    id: '224',
    name: '硬化',
    power: 0,
    type: '地',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤90%，若上次使用攻击技则本技能能耗-2，应对攻击。',
  },
  {
    id: '225',
    name: '陨石',
    power: 100,
    type: '地',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '226',
    name: '石锁',
    power: 50,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，敌方3回合无法更换精灵。',
  },
  {
    id: '227',
    name: '遁地',
    power: 0,
    type: '地',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦减伤50%并脱离，应对攻击。',
  },
  {
    id: '228',
    name: '岩土暴击',
    power: 140,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 8,
    effect: '✦造成物伤，每被攻击1次。本技能能耗永久-1。',
  },
  {
    id: '229',
    name: '地陷',
    power: 80,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 5,
    effect: '✦造成物伤，自己获得物防+70%，应对状态：本次技能威力翻倍，且物防额外+70%。',
  },
  {
    id: '230',
    name: '刺盾',
    power: 0,
    type: '地',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤70%，应对攻击：敌方获得物攻-70%。',
  },
  {
    id: '231',
    name: '不动如山',
    power: 0,
    type: '地',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤90%，应对攻击。',
  },
  {
    id: '232',
    name: '地刺',
    power: 95,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，应对状态：额外打断被应对技能。',
  },
  {
    id: '233',
    name: '捧杀',
    power: 0,
    type: '萌',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '✦减伤90%，应对攻击：敌方获得1层萌化。',
  },
  {
    id: '234',
    name: '棘刺',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦敌方获得1层棘刺印记。',
  },
  {
    id: '235',
    name: '砂糖弹球',
    power: 0,
    type: '萌',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成物伤，双方体重差越大，本次技能威力越高。',
  },
  {
    id: '236',
    name: '岩脉崩毁',
    power: 120,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成物伤，本技能能耗固定为4。',
  },
  {
    id: '237',
    name: '蓄势待发',
    power: 0,
    type: '地',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '✦自己获得1层蓄势印记。',
  },
  {
    id: '238',
    name: '壁垒',
    power: 0,
    type: '地',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤90%，应对攻击：防御技能冷却-1。',
  },
  {
    id: '239',
    name: '砂石冲撞',
    power: 80,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，若敌方本回合更换精灵，自己获得物防+100%。',
  },
  {
    id: '240',
    name: '地震',
    power: 190,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 10,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '241',
    name: '沙涌',
    power: 0,
    type: '地',
    category: 'status',
    accuracy: 100,
    energyCost: 7,
    effect: '✦将天气改为沙暴，持续8回合。',
  },
  {
    id: '242',
    name: '诡刺',
    power: 40,
    type: '幽',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '243',
    name: '魔爪',
    power: 30,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '✦造成物伤，自己回复1能量。',
  },
  {
    id: '244',
    name: '趁火打劫',
    power: 35,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，2连击，若击败敌方，本技能连击数永久+2。',
  },
  {
    id: '245',
    name: '乘胜追击',
    power: 40,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成物伤，1连击，每次使用后，本技能连击数永久+1。',
  },
  {
    id: '246',
    name: '彼岸之手',
    power: 150,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 10,
    effect: '✦造成物伤，自己每失去10%生命，本技能能耗-1。',
  },
  {
    id: '247',
    name: '撕裂',
    power: 85,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，应对状态：本次攻击吸血100%。',
  },
  {
    id: '248',
    name: '蛰针',
    power: 40,
    type: '虫',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '249',
    name: '虫茧',
    power: 0,
    type: '虫',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦自己回复20%生命，己方队伍获得1次奉献：获得10%吸血。',
  },
  {
    id: '250',
    name: '捆缚',
    power: 0,
    type: '虫',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦敌方获得2层中毒，获得1次奉献：敌方获得2层中毒。',
  },
  {
    id: '251',
    name: '虫刺',
    power: 15,
    type: '虫',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '✦造成魔伤，3连击。',
  },
  {
    id: '252',
    name: '生日蛋糕',
    power: 0,
    type: '萌',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '✦驱散自己的减益，自己的增益翻倍。',
  },
  {
    id: '253',
    name: '食腐',
    power: 0,
    type: '虫',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦驱散敌方印记，每层印记回复自己10%生命。',
  },
  {
    id: '254',
    name: '超级糖果',
    power: 100,
    type: '萌',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，自己获得萌化：本次技能威力+60。',
  },
  {
    id: '255',
    name: '虫蛊',
    power: 100,
    type: '虫',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '256',
    name: '爆米花爆破',
    power: 140,
    type: '萌',
    category: 'physical',
    accuracy: 100,
    energyCost: 5,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '257',
    name: '打鼾',
    power: 165,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 6,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '258',
    name: '尾后针',
    power: 80,
    type: '虫',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '259',
    name: '飞吻',
    power: 80,
    type: '萌',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '260',
    name: '反弹',
    power: 0,
    type: '萌',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '✦将自己的萌化转移给敌方。',
  },
  {
    id: '261',
    name: '操控',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦敌方本回合使用的技能能耗+7，持续3回合。',
  },
  {
    id: '262',
    name: '激怒',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦敌方除本回合使用的技能，其他技能能耗+3，持续3回合。',
  },
  {
    id: '263',
    name: '破罐破摔',
    power: 80,
    type: '萌',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，自己有减益时，本次技能威力+60。',
  },
  {
    id: '264',
    name: '退化',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦敌方获得1层萌化。',
  },
  {
    id: '265',
    name: '鸣叫',
    power: 40,
    type: '翼',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '266',
    name: '聚盐',
    power: 0,
    type: '草',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦2连击，每次连击自己回复5%生命和1能量，使用后本技能连击数永久+1。',
  },
  {
    id: '267',
    name: '刺藤',
    power: 45,
    type: '草',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，2连击。',
  },
  {
    id: '268',
    name: '根吸收',
    power: 0,
    type: '草',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦自己回复15%生命和4能量。',
  },
  {
    id: '269',
    name: '幽灵爆发',
    power: 140,
    type: '幽',
    category: 'special',
    accuracy: 100,
    energyCost: 5,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '270',
    name: '彗星',
    power: 240,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '✦造成魔伤，每失去5%生命，本次技能威力-10，使用后消耗全部生命。',
  },
  {
    id: '271',
    name: '午夜噪音',
    power: 20,
    type: '幽',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成魔伤，5连击。',
  },
  {
    id: '272',
    name: '掠夺',
    power: 60,
    type: '恶',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '273',
    name: '落星',
    power: 45,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '274',
    name: '水弹',
    power: 40,
    type: '水',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '275',
    name: '践踏',
    power: 130,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '276',
    name: '连续爪击',
    power: 30,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成物伤，2连击，应对状态：本次技能连击数翻倍。',
  },
  {
    id: '277',
    name: '吞噬',
    power: 150,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 6,
    effect: '✦造成物伤，若使用本技能击败敌方，回复6能量。',
  },
  {
    id: '278',
    name: '触底强击',
    power: 65,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，使用后若能量耗尽，本次技能威力+110。',
  },
  {
    id: '279',
    name: '震击',
    power: 80,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成伤害，敌方获得连击数-3。',
  },
  {
    id: '280',
    name: '脉冲光线',
    power: 40,
    type: '光',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '281',
    name: '泥浆',
    power: 40,
    type: '地',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '282',
    name: '镜像反射',
    power: 0,
    type: '光',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦减伤70%，应对攻击：本技能变为被应对的技能。',
  },
  {
    id: '283',
    name: '耀眼',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦敌方获得连击数-4。',
  },
  {
    id: '284',
    name: '逆袭',
    power: 100,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，本技能能耗每+1，威力+50。',
  },
  {
    id: '285',
    name: '顶端优势',
    power: 100,
    type: '草',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '286',
    name: '花炮',
    power: 0,
    type: '草',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦2连击，每次连击自己获得魔攻+60%。',
  },
  {
    id: '287',
    name: '流沙',
    power: 0,
    type: '地',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦敌方3回合无法更换精灵，应对防御：敌方获得双防-60%。',
  },
  {
    id: '288',
    name: '天旋地转',
    power: 60,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物理伤害，先手+1，迸发：本次技能威力+30。',
  },
  {
    id: '289',
    name: '垂死反击',
    power: 80,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成物伤，自己每失去5%生命，本次技能威力+5。',
  },
  {
    id: '290',
    name: '虫击',
    power: 90,
    type: '虫',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，应对状态：本次技能威力变为2倍，无视敌方系别抵抗。',
  },
  {
    id: '291',
    name: '虫群智慧',
    power: 0,
    type: '虫',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦己方队伍获得2次随机奉献。',
  },
  {
    id: '292',
    name: '流星火雨',
    power: 85,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，每次击败敌方，本技能威力永久+85。',
  },
  {
    id: '293',
    name: '当头棒喝',
    power: 80,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，若敌方本回合更换精灵，本次技能威力+100。',
  },
  {
    id: '294',
    name: '焚烧烙印',
    power: 0,
    type: '火',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦驱散双方所有印记，每驱散1层，敌方获得5层灼烧。',
  },
  {
    id: '295',
    name: '高温回火',
    power: 40,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成魔伤，自己脱离。',
  },
  {
    id: '296',
    name: '灼伤',
    power: 120,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '297',
    name: '导电撞击',
    power: 40,
    type: '电',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '298',
    name: '跌落',
    power: 120,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成大量物伤，自己获得物攻-50%，应对状态：改为获得物攻+50%。',
  },
  {
    id: '299',
    name: '过载回路',
    power: 0,
    type: '电',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦回合结束自己返场，下回合所选技能使用次数+1。',
  },
  {
    id: '300',
    name: '气势一击',
    power: 80,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，若上回合应对成功，本次技能威力+180。',
  },
  {
    id: '301',
    name: '寸拳',
    power: 30,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '✦造成物伤，自己回复1能量。',
  },
  {
    id: '302',
    name: '影袭',
    power: 100,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '303',
    name: '追打',
    power: 75,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，1连击，应对状态：本技能变为3连击。',
  },
  {
    id: '304',
    name: '音爆',
    power: 130,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '305',
    name: '毒泡泡',
    power: 40,
    type: '毒',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '306',
    name: '以毒攻毒',
    power: 0,
    type: '毒',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦敌方每有1层中毒效果，自己获得魔攻+30%。',
  },
  {
    id: '307',
    name: '疫病吐息',
    power: 0,
    type: '毒',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦敌方获得1层中毒印记。',
  },
  {
    id: '308',
    name: '落井下毒',
    power: 0,
    type: '毒',
    category: 'status',
    accuracy: 100,
    energyCost: 6,
    effect: '✦使敌方精灵减益的层数翻倍。',
  },
  {
    id: '309',
    name: '毒雾',
    power: 0,
    type: '毒',
    category: 'status',
    accuracy: 100,
    energyCost: 7,
    effect: '✦将敌方所有增益，转化成中毒。',
  },
  {
    id: '310',
    name: '毒液渗透',
    power: 120,
    type: '毒',
    category: 'special',
    accuracy: 100,
    energyCost: 5,
    effect: '✦造成魔伤，敌方每有1层中毒效果，本技能能耗-1，敌方获得1层中毒。',
  },
  {
    id: '311',
    name: '易燃物质',
    power: 30,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，2连击，每次连击使敌方获得2层灼烧。',
  },
  {
    id: '312',
    name: '炎枪',
    power: 100,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '313',
    name: '轴承支撑',
    power: 0,
    type: '机械',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦主动：本技能被动额外-1能耗，被动：两侧技能能耗-1，传动1。',
  },
  {
    id: '314',
    name: '背袭',
    power: 40,
    type: '幽',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成魔伤，若敌方能量等于0，造成20倍伤害。',
  },
  {
    id: '315',
    name: '恐吓',
    power: 80,
    type: '幽',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '316',
    name: '流火',
    power: 15,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '✦造成魔伤，3连击。',
  },
  {
    id: '317',
    name: '黑手',
    power: 45,
    type: '恶',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，2连击。',
  },
  {
    id: '318',
    name: '埋伏',
    power: 30,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成魔伤，3连击，若敌方本回合更换精灵，本次技能连击数+3。',
  },
  {
    id: '319',
    name: '撒娇',
    power: 30,
    type: '萌',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，3连击。自己获得萌化：威力永久+20。',
  },
  {
    id: '320',
    name: '光之矛',
    power: 30,
    type: '光',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，3连击。',
  },
  {
    id: '321',
    name: '迫近攻击',
    power: 90,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤。每次使用后，本技能威力永久+45。',
  },
  {
    id: '322',
    name: '虫鸣',
    power: 15,
    type: '虫',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成魔伤，队伍中的精灵每携带1个虫鸣，本次技能连击数+1。',
  },
  {
    id: '323',
    name: '飞断',
    power: 20,
    type: '虫',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦造成物伤，己方队伍获得1次奉献：威力+20。',
  },
  {
    id: '324',
    name: '针刺射击',
    power: 80,
    type: '草',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，若敌方本回合更换精灵，自己回复7点能量。',
  },
  {
    id: '325',
    name: '预备势',
    power: 0,
    type: '武',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦自己获得物攻+80%，应对防御：额外使敌方获得物防-80%。',
  },
  {
    id: '326',
    name: '远程访问',
    power: 0,
    type: '电',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦使敌方精灵返场。',
  },
  {
    id: '327',
    name: '感电',
    power: 60,
    type: '电',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成魔伤，每离场1次，本技能使用次数永久+1。',
  },
  {
    id: '328',
    name: '电离爆破',
    power: 0,
    type: '电',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦敌方获得速度-40，3连击。',
  },
  {
    id: '329',
    name: '落雷',
    power: 100,
    type: '电',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成魔伤，每次入场，本技能威力永久+20。',
  },
  {
    id: '330',
    name: '闪击折返',
    power: 45,
    type: '电',
    category: 'physical',
    accuracy: 100,
    energyCost: 5,
    effect: '✦造成物伤，2连击，自己脱离。',
  },
  {
    id: '331',
    name: '电磁偏转',
    power: 0,
    type: '电',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦减伤70%，应对攻击：下回合所选技能使用次数+1。',
  },
  {
    id: '332',
    name: '强制重启',
    power: 90,
    type: '电',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，应对状态：回合结束时使敌方精灵返场。',
  },
  {
    id: '333',
    name: '触电',
    power: 80,
    type: '电',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '334',
    name: '双联脉冲',
    power: 50,
    type: '电',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成魔伤，迸发：本技能使用次数+1。',
  },
  {
    id: '335',
    name: '月光合奏',
    power: 30,
    type: '萌',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，1连击，双方携带的所有精灵每有1层萌化，本次技能连击数+1。',
  },
  {
    id: '336',
    name: '示弱',
    power: 0,
    type: '萌',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦自己获得萌化：速度永久+150。',
  },
  {
    id: '337',
    name: '倾泻',
    power: 70,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，若本次攻击未被防御技能应对，则驱散双方所有印记。',
  },
  {
    id: '338',
    name: '感染病',
    power: 85,
    type: '毒',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成魔伤，若击败敌方则将中毒转化为中毒印记。',
  },
  {
    id: '339',
    name: '气沉丹田',
    power: 0,
    type: '武',
    category: 'status',
    accuracy: 100,
    energyCost: 10,
    effect: '✦自己回复60%生命，获得物攻+130%，每次应对后本技能能耗-3，使用后能耗重置。',
  },
  {
    id: '340',
    name: '回旋踢',
    power: 80,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，若敌方本回合更换精灵，本次技能威力翻倍。',
  },
  {
    id: '341',
    name: '斩断',
    power: 75,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成物伤，应对状态：额外打断被应对技能。',
  },
  {
    id: '342',
    name: '技巧打击',
    power: 35,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成物伤，应对状态：本次技能威力变为10倍。',
  },
  {
    id: '343',
    name: '一拳',
    power: 140,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 5,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '344',
    name: '爆冲',
    power: 65,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，应对状态：本次技能威力变为5倍。',
  },
  {
    id: '345',
    name: '能量刃',
    power: 80,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，每应对成功1次，本技能威力永久+90。',
  },
  {
    id: '346',
    name: '雪球',
    power: 0,
    type: '冰',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦敌方获得速度-90。',
  },
  {
    id: '347',
    name: '盐水浴',
    power: 0,
    type: '水',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦自己获得全技能能耗-2，应对防御：改为技能能耗-3。',
  },
  {
    id: '348',
    name: '打湿',
    power: 0,
    type: '水',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '✦自己获得1层湿润印记。',
  },
  {
    id: '349',
    name: '湮灭',
    power: 155,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 5,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '350',
    name: '击鼓传花',
    power: 0,
    type: '萌',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦自己脱离，下个入场精灵继承自己增益。',
  },
  {
    id: '351',
    name: '磁干扰',
    power: 60,
    type: '电',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '352',
    name: '火爪',
    power: 60,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '353',
    name: '针状物',
    power: 30,
    type: '幻',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，3连击。',
  },
  {
    id: '354',
    name: '离子火花',
    power: 80,
    type: '电',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '355',
    name: '交叉闪电',
    power: 100,
    type: '电',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '356',
    name: '雷暴',
    power: 55,
    type: '电',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '✦造成魔伤，迸发：本技能获得所有生效过的迸发，每获得1种，本技能能耗+1，威力+10。',
  },
  {
    id: '357',
    name: '虫网',
    power: 30,
    type: '虫',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '✦造成魔伤，自己回复1能量。',
  },
  {
    id: '358',
    name: '草虫冲击',
    power: 80,
    type: '虫',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，若敌方本回合更换精灵，本次威力+50且无视敌方系别抵抗。',
  },
  {
    id: '359',
    name: '虫群过境',
    power: 45,
    type: '虫',
    category: 'physical',
    accuracy: 100,
    energyCost: 5,
    effect: '✦造成物伤，2连击。己方队伍获得1次奉献：获得连击数+1。',
  },
  {
    id: '360',
    name: '虫群',
    power: 20,
    type: '虫',
    category: 'physical',
    accuracy: 100,
    energyCost: 7,
    effect: '✦造成物伤，1连击，本技能会受奉献影响。',
  },
  {
    id: '361',
    name: '翅刃',
    power: 95,
    type: '虫',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成物伤，驱散敌方所有印记，应对状态：改为偷取印记。',
  },
  {
    id: '362',
    name: '鸩毒',
    power: 75,
    type: '毒',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，敌方每有1层中毒效果，本次技能威力+10，应对状态：改为本次威力+20。',
  },
  {
    id: '363',
    name: '蝙蝠',
    power: 65,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成物伤，并吸血100%。',
  },
  {
    id: '364',
    name: '风隐',
    power: 0,
    type: '翼',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦敌方和自己均脱离，先手-1。',
  },
  {
    id: '365',
    name: '水花四溅',
    power: 20,
    type: '水',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，4连击。',
  },
  {
    id: '366',
    name: '迫害',
    power: 40,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '367',
    name: '栽赃',
    power: 150,
    type: '恶',
    category: 'special',
    accuracy: 100,
    energyCost: 6,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '368',
    name: '灾厄',
    power: 150,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对自己造成物伤，应对状态：改为对敌方造成物伤。',
  },
  {
    id: '369',
    name: '心灵洞悉',
    power: 0,
    type: '幻',
    category: 'status',
    accuracy: 100,
    energyCost: 7,
    effect: '✦敌方获得星陨印记，获得层数等于敌方印记层数。',
  },
  {
    id: '370',
    name: '二律背反',
    power: 0,
    type: '幻',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '✦敌方获得3层星陨印记，应对防御：额外使敌方星陨印记层数翻倍。',
  },
  {
    id: '371',
    name: '星轨裂变',
    power: 0,
    type: '幻',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦敌方获得2层星陨印记。',
  },
  {
    id: '372',
    name: '抛石',
    power: 140,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 30,
    effect: '✦造成物伤，回合结束时，本技能能耗永久-5。',
  },
  {
    id: '373',
    name: '裂石',
    power: 95,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，应对状态：敌方获得物防-80%。',
  },
  {
    id: '374',
    name: '双星',
    power: 100,
    type: '幻',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '375',
    name: '大爆炸',
    power: 100,
    type: '幻',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '376',
    name: '暴风眼',
    power: 0,
    type: '翼',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦行动时连击数+100%。',
  },
  {
    id: '377',
    name: '啃咬',
    power: 40,
    type: '虫',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '✦造成物伤，1连击，本技能会受奉献影响，每被影响1次，能耗永久+1。',
  },
  {
    id: '378',
    name: '飞叶',
    power: 40,
    type: '草',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '379',
    name: '虫结阵',
    power: 0,
    type: '虫',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤80%，应对攻击：己方队伍获得1次随机奉献。',
  },
  {
    id: '380',
    name: '网缚',
    power: 60,
    type: '虫',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成物伤，敌方获得物防-30%。',
  },
  {
    id: '381',
    name: '四维降解',
    power: 100,
    type: '幻',
    category: 'special',
    accuracy: 100,
    energyCost: 7,
    effect: '✦造成魔伤，敌方每有1层印记，本技能能耗-1。',
  },
  {
    id: '382',
    name: '鸣沙陷阱',
    power: 60,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成物伤，物防比敌方越高，本次技能威力越高。',
  },
  {
    id: '383',
    name: '冰捆缚',
    power: 0,
    type: '冰',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦2连击，每次连击敌方获得全技能能耗+1。',
  },
  {
    id: '384',
    name: '极寒领域',
    power: 105,
    type: '冰',
    category: 'special',
    accuracy: 100,
    energyCost: 6,
    effect: '✦造成魔伤，若敌方有冻结，本次技能威力+60，应对状态：使冻结翻倍。',
  },
  {
    id: '385',
    name: '消毒法',
    power: 115,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成魔伤，驱散敌方5层增益。',
  },
  {
    id: '386',
    name: '贮藏',
    power: 0,
    type: '虫',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦自己获得双攻+50%，每携带1个0能耗技能，额外+50%。',
  },
  {
    id: '387',
    name: '丢冰块',
    power: 90,
    type: '冰',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，敌方获得速度-30。',
  },
  {
    id: '388',
    name: '瞬间零度',
    power: 0,
    type: '冰',
    category: 'status',
    accuracy: 100,
    energyCost: 0,
    effect: '✦本回合敌方使用的技能能耗+3，应对防御：改为全技能能耗+3。',
  },
  {
    id: '389',
    name: '偷师',
    power: 30,
    type: '幻',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '✦造成物伤，自己回复1能量。',
  },
  {
    id: '390',
    name: '超新星馈赠',
    power: 0,
    type: '幻',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦敌方获得2层星陨印记，每使用1次，赋予的星陨印记层数+1。',
  },
  {
    id: '391',
    name: '空间压迫',
    power: 70,
    type: '幻',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，敌方获得1层星陨印记。',
  },
  {
    id: '392',
    name: '乱打',
    power: 25,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成魔伤，5连击。',
  },
  {
    id: '393',
    name: '毒针',
    power: 20,
    type: '毒',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '✦造成物伤，敌方获得1层中毒。',
  },
  {
    id: '394',
    name: '毒囊',
    power: 25,
    type: '毒',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成物伤，敌方获得2层中毒，应对状态：改为获得6层。',
  },
  {
    id: '395',
    name: '鞭打',
    power: 40,
    type: '萌',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '396',
    name: '星链',
    power: 0,
    type: '幻',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦2连击，每次连击使敌方获得1层星陨印记。',
  },
  {
    id: '397',
    name: '错乱',
    power: 65,
    type: '幻',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成魔伤，应对状态：敌方获得3层星陨印记。',
  },
  {
    id: '398',
    name: '风吹雪',
    power: 30,
    type: '冰',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '✦造成魔伤，自己回复1能量。',
  },
  {
    id: '399',
    name: '超导加速',
    power: 70,
    type: '电',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成魔伤，自己获得速度+30。',
  },
  {
    id: '400',
    name: '电流',
    power: 40,
    type: '电',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '401',
    name: '霜冻',
    power: 0,
    type: '冰',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦敌方获得魔防-100%。',
  },
  {
    id: '402',
    name: '冰锋横扫',
    power: 0,
    type: '冰',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成魔伤，本技能威力等于敌方精灵技能总能耗的10倍。',
  },
  {
    id: '403',
    name: '增程电池',
    power: 0,
    type: '电',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦自己获得1层蓄电印记。',
  },
  {
    id: '404',
    name: '雾气环绕',
    power: 0,
    type: '冰',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '✦回复能量，回复值等于敌方技能总能耗的一半。',
  },
  {
    id: '405',
    name: '冰点',
    power: 0,
    type: '冰',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦敌方获得5层冻结，应对防御：额外获得5层。',
  },
  {
    id: '406',
    name: '杠杆置换',
    power: 0,
    type: '机械',
    category: 'status',
    accuracy: 100,
    energyCost: 0,
    effect: '✦自己回复2能量，交换两侧技能位置。',
  },
  {
    id: '407',
    name: '金属噪音',
    power: 100,
    type: '机械',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '408',
    name: '冰锥',
    power: 40,
    type: '冰',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '409',
    name: '霜天',
    power: 0,
    type: '冰',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '✦敌方获得1层冻结，且每有1层冻结获得全技能能耗+1。',
  },
  {
    id: '410',
    name: '暴风雪',
    power: 85,
    type: '冰',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，敌方获得1层冻结。',
  },
  {
    id: '411',
    name: '冰晶坠',
    power: 90,
    type: '冰',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成物伤，敌方获得全技能能耗+1。',
  },
  {
    id: '412',
    name: '冰蛋壳',
    power: 0,
    type: '冰',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦减伤60%，应对攻击：敌方获得2层减速印记。',
  },
  {
    id: '413',
    name: '滚雪球',
    power: 55,
    type: '冰',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，敌方获得2层冻结，应对状态：额外获得2层，本次技能威力翻倍。',
  },
  {
    id: '414',
    name: '冰冻光线',
    power: 90,
    type: '冰',
    category: 'special',
    accuracy: 100,
    energyCost: 7,
    effect: '✦造成魔伤，敌方获得全技能能耗+2。',
  },
  {
    id: '415',
    name: '冬至',
    power: 0,
    type: '冰',
    category: 'status',
    accuracy: 100,
    energyCost: 7,
    effect: '✦将天气改为暴风雪，持续8回合。',
  },
  {
    id: '416',
    name: '粒子对撞',
    power: 40,
    type: '幻',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '417',
    name: '碎冰冰',
    power: 40,
    type: '冰',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，敌方每有1层冻结，本次技能威力+20。',
  },
  {
    id: '418',
    name: '赤子之心',
    power: 0,
    type: '萌',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦自己获得萌化：全技能能耗永久-3。',
  },
  {
    id: '419',
    name: '磁暴',
    power: 70,
    type: '机械',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成魔伤，本技能位于1号或3号位时威力+30，传动1。',
  },
  {
    id: '420',
    name: '钢铁洪流',
    power: 70,
    type: '机械',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，本技能位于1号位时威力+90，传动2。',
  },
  {
    id: '421',
    name: '联动装置',
    power: 0,
    type: '机械',
    category: 'status',
    accuracy: 100,
    energyCost: 0,
    effect: '✦使用后两侧技能的威力永久+20，应对防御：变为威力永久+30。',
  },
  {
    id: '422',
    name: '打雪仗',
    power: 45,
    type: '冰',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，2连击。',
  },
  {
    id: '423',
    name: '钢钻',
    power: 0,
    type: '机械',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成物伤，技能威力为两侧技能威力和的三分之一，传动1。',
  },
  {
    id: '424',
    name: '充分燃烧',
    power: 0,
    type: '火',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦使敌方身上的灼烧翻倍，并触发1次灼烧伤害。',
  },
  {
    id: '425',
    name: '爆裂飞弹',
    power: 160,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 7,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '426',
    name: '天火',
    power: 0,
    type: '火',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦敌方获得10层灼烧，应对防御：改为获得30层。',
  },
  {
    id: '427',
    name: '除厄',
    power: 60,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成魔伤，驱散自己的减益。',
  },
  {
    id: '428',
    name: '疾风连袭',
    power: 0,
    type: '翼',
    category: 'status',
    accuracy: 100,
    energyCost: 0,
    effect: '✦释放自己释放过的迅捷技能，其能耗之和的二分之一加至本技能能耗，每次使用后能耗+1。',
  },
  {
    id: '429',
    name: '龙吼',
    power: 60,
    type: '龙',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '430',
    name: '龙炮',
    power: 100,
    type: '龙',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '431',
    name: '散手',
    power: 35,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，2连击，应对状态：本技能改为6连击。',
  },
  {
    id: '432',
    name: '截拳',
    power: 90,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，应对状态：额外造成打断，回复该技能能耗的能量。',
  },
  {
    id: '433',
    name: '无影脚',
    power: 85,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，应对状态：本次技能威力变为2倍。',
  },
  {
    id: '434',
    name: '淬火',
    power: 0,
    type: '火',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '✦减伤80%，应对攻击：下次攻击技能威力翻倍。',
  },
  {
    id: '435',
    name: '焚毁',
    power: 60,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成魔伤，驱散敌方所有印记。',
  },
  {
    id: '436',
    name: '听桥',
    power: 0,
    type: '武',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '✦减伤60%，应对攻击：对敌方造成物理伤害，威力与被应对技能相等。',
  },
  {
    id: '437',
    name: '炙热波动',
    power: 55,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，敌方获得4层灼烧，应对状态：本次技能威力和赋予灼烧翻倍。',
  },
  {
    id: '438',
    name: '燃尽',
    power: 155,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成魔伤，敌方每失去5%生命，本次技能威力-5。',
  },
  {
    id: '439',
    name: '阳火增辉',
    power: 75,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，每次击败敌方，本技能威力永久翻倍。',
  },
  {
    id: '440',
    name: '破防',
    power: 0,
    type: '武',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦敌方获得双防-130%，应对防御：额外使被应对技能冷却2回合。',
  },
  {
    id: '441',
    name: '架势',
    power: 0,
    type: '龙',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦自己回复20%生命，下次技能无需蓄力。',
  },
  {
    id: '442',
    name: '绵里藏针',
    power: 50,
    type: '龙',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成魔伤，若敌方上回合没受到技能伤害，本技能威力永久+30。',
  },
  {
    id: '443',
    name: '双响炮',
    power: 25,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦造成物伤，2连击。',
  },
  {
    id: '444',
    name: '崩拳',
    power: 65,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成物伤，应对状态：自己获得物攻+100%。',
  },
  {
    id: '445',
    name: '主轴',
    power: 75,
    type: '机械',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '✦造成物伤，此技能位置不会改变。',
  },
  {
    id: '446',
    name: '龙吟',
    power: 0,
    type: '龙',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦蓄力，自己获得双攻+100%和速度+60。',
  },
  {
    id: '447',
    name: '种皮爆裂',
    power: 25,
    type: '草',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦造成物伤，2连击。',
  },
  {
    id: '448',
    name: '角击',
    power: 80,
    type: '龙',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '449',
    name: '龙威',
    power: 0,
    type: '龙',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '✦自己获得1层龙噬印记 。',
  },
  {
    id: '450',
    name: '怨力打击',
    power: 1,
    type: '龙',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦蓄力，造成魔伤，若蓄力期间受到攻击，本技能威力变为敌方技能威力的3倍。',
  },
  {
    id: '451',
    name: '龙息环爆',
    power: 55,
    type: '龙',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '✦造成魔伤，应对状态：下次技能无需蓄力。',
  },
  {
    id: '452',
    name: '飞踢',
    power: 110,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '453',
    name: '引雷',
    power: 35,
    type: '电',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成魔伤，2连击，迸发：本次技能威力+20。',
  },
  {
    id: '454',
    name: '加大功率',
    power: 0,
    type: '电',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '✦自己脱离，替换入场的精灵回复8能量。',
  },
  {
    id: '455',
    name: '能量守恒',
    power: 0,
    type: '机械',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤80%，应对攻击：两侧技能能耗永久-1。',
  },
  {
    id: '456',
    name: '齿轮切开',
    power: 130,
    type: '机械',
    category: 'physical',
    accuracy: 100,
    energyCost: 5,
    effect: '✦造成物伤，本技能位于1号或3号位时能耗-2，传动1。',
  },
  {
    id: '457',
    name: '齿轮扭矩',
    power: 80,
    type: '机械',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦造成物伤，每回合位置发生变化时，本技能威力永久+20。',
  },
  {
    id: '458',
    name: '龙爪',
    power: 120,
    type: '龙',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '459',
    name: '吹炎',
    power: 170,
    type: '龙',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '✦蓄力，造成物伤，应对状态：本次技能威力翻倍。',
  },
  {
    id: '460',
    name: '拆卸',
    power: 40,
    type: '机械',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '461',
    name: '传感器',
    power: 20,
    type: '机械',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '✦造成物伤，2连击，本技能位于1号或3号位时连击+1，传动1。',
  },
  {
    id: '462',
    name: '激流',
    power: 120,
    type: '水',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '463',
    name: '炎息',
    power: 40,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '464',
    name: '热气',
    power: 40,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '✦对敌方精灵造成魔法伤害。',
  },
  {
    id: '465',
    name: '烈焰风暴',
    power: 75,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成魔伤，敌方获得6层灼烧。',
  },
  {
    id: '466',
    name: '龙血',
    power: 0,
    type: '龙',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '✦减伤70%，本技能可以在蓄力状态下使用，应对攻击：下次技能无需蓄力。',
  },
  {
    id: '467',
    name: '隼鳞',
    power: 140,
    type: '龙',
    category: 'physical',
    accuracy: 100,
    energyCost: 5,
    effect: '✦对敌方精灵造成物理伤害。',
  },
  {
    id: '468',
    name: '恶念交换',
    power: 0,
    type: '恶',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '✦与敌方交换生命比例。',
  },
  {
    id: '469',
    name: '牵连',
    power: 85,
    type: '恶',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '✦造成魔伤，敌方每有1只力竭精灵，本次技能威力+30。',
  },
  {
    id: '470',
    name: '防御',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '减伤70%，应对攻击。',
  },
  {
    id: '471',
    name: '械斗',
    power: 45,
    type: '机械',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '造成物伤，本技能位于1号位时威力+60，传动1。',
  },
  {
    id: '472',
    name: '离子震荡',
    power: 90,
    type: '机械',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，本技能位于3号位时威力+40，传动1。',
  },
  {
    id: '473',
    name: '轴承支撑',
    power: 0,
    type: '机械',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '主动：本技能被动额外-1能耗，被动：两侧技能能耗-1，传动1。',
  },
  {
    id: '474',
    name: '能量守恒',
    power: 0,
    type: '机械',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '减伤80%，应对攻击：两侧技能能耗永久-1。',
  },
  {
    id: '475',
    name: '齿轮扭矩',
    power: 80,
    type: '机械',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，每回合位置发生变化时，本技能威力永久+20。',
  },
  {
    id: '476',
    name: '啮合传递',
    power: 0,
    type: '机械',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '自己获得速度+30，本技能位于1号或3号位时额外获得物攻+80%，传动1。',
  },
  {
    id: '477',
    name: '主轴',
    power: 75,
    type: '机械',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '造成物伤，此技能位置不会改变。',
  },
  {
    id: '478',
    name: '操控',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '敌方本回合使用的技能能耗+7，持续3回合。',
  },
  {
    id: '479',
    name: '磁暴',
    power: 70,
    type: '机械',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '造成魔伤，本技能位于1号或3号位时威力+30，传动1。',
  },
  {
    id: '480',
    name: '有效预防',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '减伤50%，应对攻击：下一次行动获得先手+1。',
  },
  {
    id: '481',
    name: '齿轮切开',
    power: 130,
    type: '机械',
    category: 'physical',
    accuracy: 100,
    energyCost: 5,
    effect: '造成物伤，本技能位于1号或3号位时能耗-2，传动1。',
  },
  {
    id: '482',
    name: '阻断',
    power: 75,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '造成魔伤，应对状态：额外打断被应对技能。',
  },
  {
    id: '483',
    name: '微型斥候',
    power: 75,
    type: '机械',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，自己每受到一次抵抗伤害，本技能威力永久+20。',
  },
  {
    id: '484',
    name: '相位移动',
    power: 0,
    type: '机械',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '减伤50%，本技能位于1号位或3号位时，额外减伤40%，应对攻击，传动1。',
  },
  {
    id: '485',
    name: '防反',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '减伤70%，应对攻击：自己获得物攻和魔攻+70%。',
  },
  {
    id: '486',
    name: '蜡质膜',
    power: 0,
    type: '草',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '减伤80%，应对攻击：回复3能量。',
  },
  {
    id: '487',
    name: '火焰护盾',
    power: 0,
    type: '火',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '减伤70%，应对攻击：敌方获得6层灼烧。',
  },
  {
    id: '488',
    name: '水泡盾',
    power: 0,
    type: '水',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '减伤80%，应对攻击：自己获得魔攻+70%。',
  },
  {
    id: '489',
    name: '透射',
    power: 60,
    type: '光',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '490',
    name: '扬沙',
    power: 60,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '491',
    name: '雪替身',
    power: 0,
    type: '冰',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '减伤70%，应对攻击：回复能量，回复值等于被应对技能能耗的2倍。',
  },
  {
    id: '492',
    name: '升龙咆哮',
    power: 200,
    type: '龙',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '蓄力，对敌方造成魔法伤害。',
  },
  {
    id: '493',
    name: '集中',
    power: 0,
    type: '电',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '减伤80%，应对攻击：自己回合结束返场。',
  },
  {
    id: '494',
    name: '溃烂触碰',
    power: 60,
    type: '毒',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '495',
    name: '噬心',
    power: 60,
    type: '虫',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '496',
    name: '反击拳',
    power: 25,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '造成物伤，2连击，若后手攻击，改为3连击。',
  },
  {
    id: '497',
    name: '羽翼庇护',
    power: 0,
    type: '翼',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '减伤70%，应对攻击：自己获得连击数+2。',
  },
  {
    id: '498',
    name: '碰爪',
    power: 60,
    type: '萌',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '499',
    name: '虚化',
    power: 0,
    type: '幽',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '减伤80%，应对攻击：自己获得魔防+70%。',
  },
  {
    id: '500',
    name: '等价交换',
    power: 0,
    type: '恶',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '减伤90%，应对攻击：自己获得50%吸血。',
  },
  {
    id: '501',
    name: '金属噪音',
    power: 100,
    type: '机械',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '502',
    name: '星云漩涡',
    power: 60,
    type: '幻',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '503',
    name: '力量增效',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '自己获得物攻+100%。',
  },
  {
    id: '504',
    name: '魔法增效',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 0,
    effect: '自己获得魔攻+70%。',
  },
  {
    id: '505',
    name: '空间压迫',
    power: 70,
    type: '幻',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，敌方获得1层星陨印记。',
  },
  {
    id: '506',
    name: '坍缩',
    power: 85,
    type: '幻',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，若击败敌方，自己获得魔攻+70%。',
  },
  {
    id: '507',
    name: '冥想',
    power: 0,
    type: '幻',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '减伤80%，应对攻击：敌方获得2层星陨印记。',
  },
  {
    id: '508',
    name: '心灵洞悉',
    power: 0,
    type: '幻',
    category: 'status',
    accuracy: 100,
    energyCost: 7,
    effect: '敌方获得星陨印记，获得层数等于敌方印记层数。',
  },
  {
    id: '509',
    name: '热砂',
    power: 80,
    type: '地',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '510',
    name: '落石',
    power: 55,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '造成物伤，1连击。',
  },
  {
    id: '511',
    name: '硬化',
    power: 0,
    type: '地',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '减伤90%，若上次使用攻击技则本技能能耗-2，应对攻击。',
  },
  {
    id: '512',
    name: '血气',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '减伤60%，应对攻击：本回合受到致命伤害时，保留1生命值。',
  },
  {
    id: '513',
    name: '气势一击',
    power: 80,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，若上回合应对成功，本次技能威力+180。',
  },
  {
    id: '514',
    name: '能量刃',
    power: 80,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，每应对成功1次，本技能威力永久+90。',
  },
  {
    id: '515',
    name: '借用',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 0,
    effect: '每回合随机变成己方队伍中其他精灵的技能。',
  },
  {
    id: '516',
    name: '无畏之心',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 5,
    effect: '减伤100%，应对攻击：减免的伤害变为回复自己生命，且本技能能耗永久+2。',
  },
  {
    id: '517',
    name: '倾泻',
    power: 70,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，若本次攻击未被防御技能应对，则驱散双方所有印记。',
  },
  {
    id: '518',
    name: '晒太阳',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '驱散敌方所有增益。',
  },
  {
    id: '519',
    name: '鸣叫',
    power: 40,
    type: '翼',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '520',
    name: '乘风',
    power: 0,
    type: '翼',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '自己获得速度+120。',
  },
  {
    id: '521',
    name: '音波弹',
    power: 60,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '造成魔伤，1连击。',
  },
  {
    id: '522',
    name: '疾风刺',
    power: 25,
    type: '翼',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '造成物伤，1连击，若先于敌方攻击，改为3连击。',
  },
  {
    id: '523',
    name: '锐利眼神',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '敌方获得物防和魔防-120%。',
  },
  {
    id: '524',
    name: '先发制人',
    power: 55,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '造成物理伤害，先手+1。',
  },
  {
    id: '525',
    name: '翼击',
    power: 50,
    type: '翼',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，迅捷。',
  },
  {
    id: '526',
    name: '羽化加速',
    power: 0,
    type: '翼',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '自己获得全技能威力+20，迅捷。',
  },
  {
    id: '527',
    name: '能量炮',
    power: 50,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，2连击。',
  },
  {
    id: '528',
    name: '见招拆招',
    power: 65,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '造成物伤，若上回合使用状态技能，本次技能威力+55。',
  },
  {
    id: '529',
    name: '暴风眼',
    power: 0,
    type: '翼',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '行动时连击数+100%。',
  },
  {
    id: '530',
    name: '吞噬',
    power: 150,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 6,
    effect: '造成物伤，若使用本技能击败敌方，回复6能量。',
  },
  {
    id: '531',
    name: '俯冲',
    power: 170,
    type: '翼',
    category: 'physical',
    accuracy: 100,
    energyCost: 7,
    effect: '造成物伤，先手+1。',
  },
  {
    id: '532',
    name: '星星撞击',
    power: 90,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '533',
    name: '花香',
    power: 60,
    type: '草',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '534',
    name: '火焰冲锋',
    power: 60,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '535',
    name: '泡沫',
    power: 60,
    type: '水',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '536',
    name: '冰爪',
    power: 80,
    type: '冰',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '537',
    name: '球状闪电',
    power: 60,
    type: '电',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '538',
    name: '毒沼',
    power: 80,
    type: '毒',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '539',
    name: '贯手',
    power: 80,
    type: '武',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '540',
    name: '风矢',
    power: 80,
    type: '翼',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '541',
    name: '灵媒',
    power: 100,
    type: '幽',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '542',
    name: '恶能量',
    power: 60,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '543',
    name: '伺机而动',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '下一次攻击时，技能威力+70。',
  },
  {
    id: '544',
    name: '热身运动',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '自己获得连击数+3。',
  },
  {
    id: '545',
    name: '三连破',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '自己获得物攻+30%，3连击。',
  },
  {
    id: '546',
    name: '乱打',
    power: 25,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '造成魔伤，5连击。',
  },
  {
    id: '547',
    name: '埋伏',
    power: 30,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '造成魔伤，3连击，若敌方本回合更换精灵，本次技能连击数+3。',
  },
  {
    id: '548',
    name: '龙卷风',
    power: 70,
    type: '翼',
    category: 'physical',
    accuracy: 100,
    energyCost: 5,
    effect: '造成物伤，迅捷，应对状态：本次技能威力变为1.5倍。',
  },
  {
    id: '549',
    name: '突袭',
    power: 70,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '造成魔伤，应对状态：本次技能威力变为3倍。',
  },
  {
    id: '550',
    name: '复写',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 0,
    effect: '每回合随机变成自己未携带的技能，且该技能能耗-2。',
  },
  {
    id: '551',
    name: '光之矛',
    power: 30,
    type: '光',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，3连击。',
  },
  {
    id: '552',
    name: '水花四溅',
    power: 20,
    type: '水',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，4连击。',
  },
  {
    id: '553',
    name: '缠丝劲',
    power: 25,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '造成物伤，2连击。',
  },
  {
    id: '554',
    name: '快速移动',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '自己获得速度+80，应对防御：改为速度+160。',
  },
  {
    id: '555',
    name: '天光',
    power: 95,
    type: '光',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，本技能系别和天气系别相同。',
  },
  {
    id: '556',
    name: '潮涌',
    power: 80,
    type: '水',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '557',
    name: '叠势',
    power: 25,
    type: '武',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，2连击，每成功应对1次，本技能连击数永久+2。',
  },
  {
    id: '558',
    name: '连续爪击',
    power: 30,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '造成物伤，2连击，应对状态：本次技能连击数翻倍。',
  },
  {
    id: '559',
    name: '冰锥',
    power: 40,
    type: '冰',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '560',
    name: '寒风吹',
    power: 70,
    type: '冰',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，敌方获得魔防-50%。',
  },
  {
    id: '561',
    name: '丢冰块',
    power: 90,
    type: '冰',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，敌方获得速度-30。',
  },
  {
    id: '562',
    name: '碎冰冰',
    power: 40,
    type: '冰',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，敌方每有1层冻结，本次技能威力+20。',
  },
  {
    id: '563',
    name: '休息回复',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '自己回复30%生命。',
  },
  {
    id: '564',
    name: '雪球',
    power: 0,
    type: '冰',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '敌方获得速度-90。',
  },
  {
    id: '565',
    name: '霜降',
    power: 0,
    type: '冰',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '敌方获得4层冻结。',
  },
  {
    id: '566',
    name: '滚雪球',
    power: 55,
    type: '冰',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，敌方获得2层冻结，应对状态：额外获得2层，本次技能威力翻倍。',
  },
  {
    id: '567',
    name: '雾气环绕',
    power: 0,
    type: '冰',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '回复能量，回复值等于敌方技能总能耗的一半。',
  },
  {
    id: '568',
    name: '瞬间零度',
    power: 0,
    type: '冰',
    category: 'status',
    accuracy: 100,
    energyCost: 0,
    effect: '本回合敌方使用的技能能耗+3，应对防御：改为全技能能耗+3。',
  },
  {
    id: '569',
    name: '寸拳',
    power: 30,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '造成物伤，自己回复1能量。',
  },
  {
    id: '570',
    name: '崩拳',
    power: 65,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '造成物伤，应对状态：自己获得物攻+100%。',
  },
  {
    id: '571',
    name: '截拳',
    power: 85,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，应对状态：额外造成打断，回复该技能能耗的能量。',
  },
  {
    id: '572',
    name: '诋毁',
    power: 80,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '573',
    name: '黑手',
    power: 45,
    type: '恶',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，2连击。',
  },
  {
    id: '574',
    name: '跌落',
    power: 120,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成大量物伤，自己获得物攻-50%，应对状态：改为获得物攻+50%。',
  },
  {
    id: '575',
    name: '力量吞噬',
    power: 0,
    type: '恶',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '敌方获得全技能威力-20，自己获得全技能威力+20。',
  },
  {
    id: '576',
    name: '恐吓',
    power: 80,
    type: '幽',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '577',
    name: '撞鬼',
    power: 120,
    type: '幽',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '578',
    name: '打鼾',
    power: 165,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 6,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '579',
    name: '应激反应',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '自己回复25%生命，应对防御：改为回复50%生命。',
  },
  {
    id: '580',
    name: '提气',
    power: 0,
    type: '武',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '自己获得全技能威力+40，若敌方本回合更换精灵，额外获得威力+50。',
  },
  {
    id: '581',
    name: '冰墙',
    power: 0,
    type: '冰',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '减伤80%，应对攻击：敌方获得2层冻结。',
  },
  {
    id: '582',
    name: '猛烈撞击',
    power: 65,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '583',
    name: '炎息',
    power: 40,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '584',
    name: '火焰箭',
    power: 80,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '585',
    name: '龙吟',
    power: 0,
    type: '龙',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '蓄力，自己获得双攻+150%和速度+80。',
  },
  {
    id: '586',
    name: '守护咒',
    power: 0,
    type: '龙',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '减伤90%，应对攻击。巧变：龙系状态技能。',
  },
  {
    id: '587',
    name: '龙炮',
    power: 100,
    type: '龙',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '588',
    name: '引燃',
    power: 0,
    type: '火',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '敌方获得10层灼烧。',
  },
  {
    id: '589',
    name: '流星火雨',
    power: 75,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，每次击败敌方，本技能威力永久+75。',
  },
  {
    id: '590',
    name: '焚尽',
    power: 0,
    type: '火',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '驱散自己所有印记，每驱散1层，获得物攻+50%。巧变：火系攻击技能。',
  },
  {
    id: '591',
    name: '淬火',
    power: 0,
    type: '火',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '减伤80%，应对攻击：下次攻击技能威力翻倍。',
  },
  {
    id: '592',
    name: '龙之利爪',
    power: 130,
    type: '龙',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '蓄力，造成物伤并吸血50%。',
  },
  {
    id: '593',
    name: '跺地',
    power: 80,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '594',
    name: '闪燃',
    power: 40,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '造成物伤，应对状态：本次技能威力变为4倍。',
  },
  {
    id: '595',
    name: '隼鳞',
    power: 140,
    type: '龙',
    category: 'physical',
    accuracy: 100,
    energyCost: 5,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '596',
    name: '冲撞',
    power: 135,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 7,
    effect: '造成物伤，回合结束时，本技能能耗永久-1。',
  },
  {
    id: '597',
    name: '偷袭',
    power: 85,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，应对状态：本次技能威力变为3倍。',
  },
  {
    id: '598',
    name: '吓退',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '减伤60%，应对攻击：敌方脱离。',
  },
  {
    id: '599',
    name: '火云车',
    power: 140,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 5,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '600',
    name: '吹炎',
    power: 170,
    type: '龙',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '蓄力，造成物伤，应对状态：本次技能威力翻倍。',
  },
  {
    id: '601',
    name: '同频',
    power: 125,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔法伤害，巧变：魔攻技能。',
  },
  {
    id: '602',
    name: '音爆',
    power: 130,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '603',
    name: '杠杆置换',
    power: 0,
    type: '机械',
    category: 'status',
    accuracy: 100,
    energyCost: 0,
    effect: '自己回复2能量，交换两侧技能位置。',
  },
  {
    id: '604',
    name: '聒噪',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '敌方获得全攻击技能能耗+2，持续3回合。',
  },
  {
    id: '605',
    name: '追打',
    power: 75,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，1连击，应对状态：本技能变为3连击。',
  },
  {
    id: '606',
    name: '午夜噪音',
    power: 20,
    type: '幽',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '造成魔伤，5连击。',
  },
  {
    id: '607',
    name: '排气',
    power: 0,
    type: '机械',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '敌方获得全技能威力-20，若自己受到抵抗伤害，敌方额外获得全技能威力-20，使用后重置',
  },
  {
    id: '608',
    name: '鞭打',
    power: 40,
    type: '萌',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '609',
    name: '鼓劲',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '自己获得魔防+170%。',
  },
  {
    id: '610',
    name: '超级糖果',
    power: 100,
    type: '萌',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，自己获得萌化：本次技能威力+60。',
  },
  {
    id: '611',
    name: '清洗',
    power: 0,
    type: '水',
    category: 'status',
    accuracy: 100,
    energyCost: 0,
    effect: '驱散自己的减益，自己每有1层减益，本技能能耗-1，巧变：水系攻击技能。',
  },
  {
    id: '612',
    name: '水幕冲击',
    power: 100,
    type: '水',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '613',
    name: '潮汐',
    power: 0,
    type: '水',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '减伤60%，应对攻击：自己获得1层湿润印记。',
  },
  {
    id: '614',
    name: '砂糖弹球',
    power: 0,
    type: '萌',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '造成物伤，双方体重差越大，本次技能威力越高。',
  },
  {
    id: '615',
    name: '生日蛋糕',
    power: 0,
    type: '萌',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '驱散自己的减益，自己的增益翻倍。',
  },
  {
    id: '616',
    name: '水光冲击',
    power: 140,
    type: '水',
    category: 'special',
    accuracy: 100,
    energyCost: 5,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '617',
    name: '加油',
    power: 0,
    type: '萌',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '自己获得1层萌芽印记。',
  },
  {
    id: '618',
    name: '撒娇',
    power: 30,
    type: '萌',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，3连击。自己获得萌化：威力永久+20。',
  },
  {
    id: '619',
    name: '爆米花爆破',
    power: 140,
    type: '萌',
    category: 'physical',
    accuracy: 100,
    energyCost: 5,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '620',
    name: '盐水浴',
    power: 0,
    type: '水',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '自己获得全技能能耗-2，应对防御：改为技能能耗-3。',
  },
  {
    id: '621',
    name: '徒长',
    power: 0,
    type: '草',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '自己回复10能量。',
  },
  {
    id: '622',
    name: '蓄水',
    power: 0,
    type: '水',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '下次使用的技能能耗-6。',
  },
  {
    id: '623',
    name: '虹光冲击',
    power: 100,
    type: '光',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '624',
    name: '麻痹',
    power: 0,
    type: '电',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '敌方先手-1，应对防御：额外使敌方获得双攻-70%。',
  },
  {
    id: '625',
    name: '毒孢子',
    power: 0,
    type: '毒',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '敌方获得5层中毒。',
  },
  {
    id: '626',
    name: '假寐',
    power: 0,
    type: '虫',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '自己回复2能量，己方队伍获得1次奉献：能耗-2。',
  },
  {
    id: '627',
    name: '贪婪',
    power: 0,
    type: '恶',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '自己获得100%吸血。',
  },
  {
    id: '628',
    name: '超维投射',
    power: 0,
    type: '幻',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '敌方获得4层星陨印记。',
  },
  {
    id: '629',
    name: '示弱',
    power: 0,
    type: '萌',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '自己获得萌化：速度永久+150。',
  },
  {
    id: '630',
    name: '一拳',
    power: 140,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 5,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '631',
    name: '当头棒喝',
    power: 80,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，若敌方本回合更换精灵，本次技能威力+100。',
  },
  {
    id: '632',
    name: '许愿星',
    power: 110,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '633',
    name: '赤子之心',
    power: 0,
    type: '萌',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '自己获得萌化：全技能能耗永久-3。',
  },
  {
    id: '634',
    name: '击鼓传花',
    power: 0,
    type: '萌',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '自己脱离，下个入场精灵继承自己增益。',
  },
  {
    id: '635',
    name: '打湿',
    power: 0,
    type: '水',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '自己获得1层湿润印记。',
  },
  {
    id: '636',
    name: '取念',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 0,
    effect: '每回合随机变成敌方任意精灵的技能，且该技能能耗-2。',
  },
  {
    id: '637',
    name: '预备势',
    power: 0,
    type: '武',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '自己获得物攻+80%，应对防御：额外使敌方获得物防-80%。',
  },
  {
    id: '638',
    name: '破防',
    power: 0,
    type: '武',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '敌方获得双防-70%，应对防御：额外使被应对技能冷却2回合。',
  },
  {
    id: '639',
    name: '主场优势',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '自己获得1层攻击印记。',
  },
  {
    id: '640',
    name: '落星',
    power: 45,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '641',
    name: '蝙蝠',
    power: 65,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '造成物伤，并吸血100%。',
  },
  {
    id: '642',
    name: '杂耍',
    power: 115,
    type: '恶',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，巧变：吸血相关技能。',
  },
  {
    id: '643',
    name: '骗局',
    power: 110,
    type: '恶',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '造成魔伤，能量不足时，消耗5%生命代替1能量。',
  },
  {
    id: '644',
    name: '伪造账单',
    power: 0,
    type: '恶',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '若敌方本回合回复生命，改为失去2倍。先手+1。',
  },
  {
    id: '645',
    name: '趁火打劫',
    power: 35,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，2连击，若击败敌方，本技能连击数永久+2。',
  },
  {
    id: '646',
    name: '欺诈契约',
    power: 0,
    type: '恶',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '与敌方交换增益和减益。',
  },
  {
    id: '647',
    name: '栽赃',
    power: 150,
    type: '恶',
    category: 'special',
    accuracy: 100,
    energyCost: 6,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '648',
    name: '暗箱操作',
    power: 0,
    type: '恶',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '自己获得双攻和双防-100%，应对防御：改为敌方获得双攻和双防-100%。',
  },
  {
    id: '649',
    name: '假冒',
    power: 0,
    type: '恶',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '自己的生命比例变为与敌方生命比例相同，巧变：恶系攻击技能。',
  },
  {
    id: '650',
    name: '暗突袭',
    power: 70,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '造成物伤，吸血50%，应对状态：本次技能威力翻倍。',
  },
  {
    id: '651',
    name: '甜心续航',
    power: 0,
    type: '萌',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '自己和敌方获得萌化：回复40%生命。',
  },
  {
    id: '652',
    name: '瘴气喷射',
    power: 100,
    type: '毒',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '653',
    name: '毒雾',
    power: 0,
    type: '毒',
    category: 'status',
    accuracy: 100,
    energyCost: 7,
    effect: '将敌方所有增益，转化成中毒。',
  },
  {
    id: '654',
    name: '恶意逃离',
    power: 0,
    type: '恶',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '脱离，应对防御：额外使敌方攻击技能能耗+4。',
  },
  {
    id: '655',
    name: '剧毒',
    power: 0,
    type: '毒',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '敌方获得3层中毒，应对防御：改为获得8层。',
  },
  {
    id: '656',
    name: '虫蛊',
    power: 100,
    type: '虫',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '657',
    name: '捆缚',
    power: 0,
    type: '虫',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '敌方获得2层中毒，获得1次奉献：敌方获得2层中毒。',
  },
  {
    id: '658',
    name: '食腐',
    power: 0,
    type: '虫',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '驱散敌方印记，每层印记回复自己10%生命。',
  },
  {
    id: '659',
    name: '尾后针',
    power: 80,
    type: '虫',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '660',
    name: '嗜痛',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '减伤80%，应对攻击：期间自己每次受到伤害，获得双攻+40%。',
  },
  {
    id: '661',
    name: '流火',
    power: 15,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '造成魔伤，3连击。',
  },
  {
    id: '662',
    name: '腐蚀酸液',
    power: 35,
    type: '毒',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '造成魔伤，敌方获得2层中毒。',
  },
  {
    id: '663',
    name: '易燃物质',
    power: 30,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，2连击，每次连击使敌方获得2层灼烧。',
  },
  {
    id: '664',
    name: '烈焰风暴',
    power: 75,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '造成魔伤，敌方获得6层灼烧。',
  },
  {
    id: '665',
    name: '腐化',
    power: 0,
    type: '毒',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '敌方每有1层中毒效果，敌方获得双攻-30%。',
  },
  {
    id: '666',
    name: '落井下毒',
    power: 0,
    type: '毒',
    category: 'status',
    accuracy: 100,
    energyCost: 6,
    effect: '使敌方精灵减益的层数翻倍。',
  },
  {
    id: '667',
    name: '毒液渗透',
    power: 120,
    type: '毒',
    category: 'special',
    accuracy: 100,
    energyCost: 5,
    effect: '造成魔伤，敌方每有1层中毒效果，本技能能耗-1，敌方获得1层中毒。',
  },
  {
    id: '668',
    name: '泥浆铠甲',
    power: 0,
    type: '地',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '自己获得物攻和物防+60%，应对防御：额外使自己的增益翻倍。',
  },
  {
    id: '669',
    name: '化劲',
    power: 0,
    type: '武',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '自己获得全技能威力+40。',
  },
  {
    id: '670',
    name: '充分燃烧',
    power: 0,
    type: '火',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '使敌方身上的灼烧翻倍，并触发1次灼烧伤害。',
  },
  {
    id: '671',
    name: '天火',
    power: 0,
    type: '火',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '敌方获得10层灼烧，应对防御：改为获得30层。',
  },
  {
    id: '672',
    name: '焚烧烙印',
    power: 0,
    type: '火',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '驱散双方所有印记，每驱散1层，敌方获得5层灼烧。',
  },
  {
    id: '673',
    name: '石肤术',
    power: 0,
    type: '地',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '自己获得物防+160%和魔防-60%。',
  },
  {
    id: '674',
    name: '陨石',
    power: 100,
    type: '地',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '675',
    name: '诡刺',
    power: 40,
    type: '幽',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '676',
    name: '勾魂',
    power: 0,
    type: '幽',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '偷取敌方3能量。',
  },
  {
    id: '677',
    name: '报复',
    power: 0,
    type: '幽',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '减伤70%，应对攻击：敌方失去3能量。',
  },
  {
    id: '678',
    name: '嘲弄',
    power: 0,
    type: '幽',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '自己获得魔攻+90%，若敌方本回合更换精灵，自己获得速度+70。',
  },
  {
    id: '679',
    name: '入梦',
    power: 0,
    type: '幽',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '敌方下回合回复的能量-5，冷却2回合。',
  },
  {
    id: '680',
    name: '降灵',
    power: 0,
    type: '幽',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '敌方获得1层降灵印记。',
  },
  {
    id: '681',
    name: '幽灵爆发',
    power: 140,
    type: '幽',
    category: 'special',
    accuracy: 100,
    energyCost: 5,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '682',
    name: '恶作剧',
    power: 0,
    type: '幽',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '敌方失去3能量，应对防御：改为敌方失去6能量。',
  },
  {
    id: '683',
    name: '惊吓盒子',
    power: 80,
    type: '幽',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，应对状态：使敌方失去6能量。',
  },
  {
    id: '684',
    name: '二律背反',
    power: 0,
    type: '幻',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '敌方获得3层星陨印记，应对防御：额外使敌方星陨印记层数翻倍。',
  },
  {
    id: '685',
    name: '星轨裂变',
    power: 0,
    type: '幻',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '敌方获得2层星陨印记。',
  },
  {
    id: '686',
    name: '精神扰乱',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 0,
    effect: '敌方获得全技能能耗+1，应对防御：改为能耗+3。',
  },
  {
    id: '687',
    name: '双星',
    power: 100,
    type: '幻',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '688',
    name: '电流',
    power: 40,
    type: '电',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '689',
    name: '光球',
    power: 80,
    type: '光',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '690',
    name: '超导',
    power: 95,
    type: '电',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，迸发：本技能能耗-1。',
  },
  {
    id: '691',
    name: '远程访问',
    power: 0,
    type: '电',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '使敌方精灵返场。',
  },
  {
    id: '692',
    name: '色散',
    power: 80,
    type: '光',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，对混血精灵造成伤害+50%。',
  },
  {
    id: '693',
    name: '电磁偏转',
    power: 0,
    type: '电',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '减伤70%，应对攻击：下回合所选技能使用次数+1。',
  },
  {
    id: '694',
    name: '电离爆破',
    power: 0,
    type: '电',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '敌方获得速度-40，3连击。',
  },
  {
    id: '695',
    name: '双联脉冲',
    power: 50,
    type: '电',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '造成魔伤，迸发：本技能使用次数+1。',
  },
  {
    id: '696',
    name: '增程电池',
    power: 0,
    type: '电',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '自己获得1层蓄电印记。',
  },
  {
    id: '697',
    name: '落雷',
    power: 35,
    type: '电',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，每次入场，本技能威力永久+40。',
  },
  {
    id: '698',
    name: '踏雷',
    power: 0,
    type: '电',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '自己回合结束时返场，携带的攻击技能下回合获得1个已触发过的进发效果，应对防御：改为获得所有触发过的迸发效果。',
  },
  {
    id: '699',
    name: '放晴',
    power: 0,
    type: '光',
    category: 'status',
    accuracy: 100,
    energyCost: 0,
    effect: '光系技能威力永久+50%，应对防御：改为永久+100%。',
  },
  {
    id: '700',
    name: '加大功率',
    power: 0,
    type: '电',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '自己脱离，替换入场的精灵回复8能量。',
  },
  {
    id: '701',
    name: '泥巴喷射',
    power: 60,
    type: '地',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '702',
    name: '蓄势待发',
    power: 0,
    type: '地',
    category: 'status',
    accuracy: 100,
    energyCost: 4,
    effect: '自己获得1层蓄势印记。',
  },
  {
    id: '703',
    name: '流沙',
    power: 0,
    type: '地',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '敌方3回合无法更换精灵，应对防御：敌方获得双防-60%。',
  },
  {
    id: '704',
    name: '耀眼',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '敌方获得连击数-4。',
  },
  {
    id: '705',
    name: '镜像反射',
    power: 0,
    type: '光',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '减伤70%，应对攻击：本技能变为被应对的技能。',
  },
  {
    id: '706',
    name: '棘刺',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '敌方获得1层棘刺印记。',
  },
  {
    id: '707',
    name: '减压阀',
    power: 0,
    type: '机械',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '主动：本技能被动永久额外+20威力，被动：两侧技能威力+10，传动1。',
  },
  {
    id: '708',
    name: '联动装置',
    power: 0,
    type: '机械',
    category: 'status',
    accuracy: 100,
    energyCost: 0,
    effect: '使用后两侧技能的威力永久+20，应对防御：变为威力永久+30。',
  },
  {
    id: '709',
    name: '闪光冲击',
    power: 100,
    type: '光',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '710',
    name: '漫反射',
    power: 0,
    type: '光',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '每种系别中的至多1个技能，威力+35。',
  },
  {
    id: '711',
    name: '星链',
    power: 0,
    type: '幻',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '2连击，每次连击使敌方获得1层星陨印记。',
  },
  {
    id: '712',
    name: '摇篮曲',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 5,
    effect: '敌方获得全技能能耗+3，应对防御：额外造成打断，且敌方下回合获得眩晕。',
  },
  {
    id: '713',
    name: '咆哮',
    power: 0,
    type: '普通',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '敌方获得物攻-60%，速度-60。',
  },
  {
    id: '714',
    name: '偷师',
    power: 30,
    type: '幻',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '造成物伤，自己回复1能量。',
  },
  {
    id: '715',
    name: '针状物',
    power: 30,
    type: '幻',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，3连击。',
  },
  {
    id: '716',
    name: '叠加态',
    power: 0,
    type: '幻',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '自己获得随机16层属性增益，巧变：幻系攻击技能。',
  },
  {
    id: '717',
    name: '念力膨胀',
    power: 80,
    type: '幻',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '718',
    name: '顶端优势',
    power: 100,
    type: '草',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '719',
    name: '藤绞',
    power: 80,
    type: '草',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '造成物伤，自己回复5能量。',
  },
  {
    id: '720',
    name: '花炮',
    power: 0,
    type: '草',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '2连击，每次连击自己获得魔攻+60%。',
  },
  {
    id: '721',
    name: '孢子',
    power: 0,
    type: '草',
    category: 'status',
    accuracy: 100,
    energyCost: 3,
    effect: '敌方获得1层寄生。',
  },
  {
    id: '722',
    name: '芳香诱引',
    power: 0,
    type: '草',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '自己获得连击数+2，应对防御：额外造成打断，且敌方下回合获得眩晕。',
  },
  {
    id: '723',
    name: '电弧',
    power: 80,
    type: '电',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，迸发：本次技能威力+40。',
  },
  {
    id: '724',
    name: '过载回路',
    power: 0,
    type: '电',
    category: 'status',
    accuracy: 100,
    energyCost: 1,
    effect: '回合结束自己返场，下回合所选技能使用次数+1。',
  },
  {
    id: '725',
    name: '超新星馈赠',
    power: 0,
    type: '幻',
    category: 'status',
    accuracy: 100,
    energyCost: 2,
    effect: '敌方获得2层星陨印记，每使用1次，赋予的星陨印记层数+1。',
  },
  {
    id: '726',
    name: '气波',
    power: 40,
    type: '武',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '727',
    name: '冷风',
    power: 60,
    type: '冰',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '728',
    name: '打雪仗',
    power: 45,
    type: '冰',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，2连击。',
  },
  {
    id: '729',
    name: '冰晶坠',
    power: 90,
    type: '冰',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '造成物伤，敌方获得全技能能耗+1。',
  },
  {
    id: '730',
    name: '冰冻光线',
    power: 90,
    type: '冰',
    category: 'special',
    accuracy: 100,
    energyCost: 7,
    effect: '造成魔伤，敌方获得全技能能耗+2。',
  },
  {
    id: '731',
    name: '冰雹',
    power: 105,
    type: '冰',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '造成物伤，应对状态：额外使敌方获得全技能能耗+3。',
  },
  {
    id: '732',
    name: '极寒领域',
    power: 105,
    type: '冰',
    category: 'special',
    accuracy: 100,
    energyCost: 6,
    effect: '造成魔伤，若敌方有冻结，本次技能威力+60，应对状态：使冻结翻倍。',
  },
  {
    id: '733',
    name: '汲取',
    power: 30,
    type: '草',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '造成魔伤，并吸血100%。',
  },
  {
    id: '734',
    name: '种皮爆裂',
    power: 25,
    type: '草',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '造成物伤，2连击。',
  },
  {
    id: '735',
    name: '棘突',
    power: 100,
    type: '草',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '736',
    name: '筛管奔流',
    power: 80,
    type: '草',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，自己生命大于80%时，本次技能威力+75。',
  },
  {
    id: '737',
    name: '刺藤',
    power: 45,
    type: '草',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，2连击。',
  },
  {
    id: '738',
    name: '叶绿光束',
    power: 120,
    type: '草',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '739',
    name: '孢子爆散',
    power: 30,
    type: '草',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，1连击，每次使用后，本技能连击数永久+2。',
  },
  {
    id: '740',
    name: '光能聚集',
    power: 100,
    type: '草',
    category: 'special',
    accuracy: 100,
    energyCost: 7,
    effect: '造成魔伤，每次使用其他草系技能后，本技能威力永久+60。',
  },
  {
    id: '741',
    name: '抽枝',
    power: 90,
    type: '草',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '造成物伤，应对状态：自己回复50%生命和5能量。',
  },
  {
    id: '742',
    name: '蛰针',
    power: 40,
    type: '虫',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '743',
    name: '虫网',
    power: 30,
    type: '虫',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '造成魔伤，自己回复1能量。',
  },
  {
    id: '744',
    name: '飞断',
    power: 20,
    type: '虫',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '造成物伤，己方队伍获得1次奉献：威力+20。',
  },
  {
    id: '745',
    name: '虫鸣',
    power: 15,
    type: '虫',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '造成魔伤，队伍中的精灵每携带1个虫鸣，本次技能连击数+1。',
  },
  {
    id: '746',
    name: '虫刺',
    power: 15,
    type: '虫',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '造成魔伤，3连击。',
  },
  {
    id: '747',
    name: '网缚',
    power: 60,
    type: '虫',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '造成物伤，敌方获得物防-30%。',
  },
  {
    id: '748',
    name: '虫群过境',
    power: 30,
    type: '虫',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，2连击。己方队伍获得1次奉献：获得连击数+1。',
  },
  {
    id: '749',
    name: '虫群',
    power: 20,
    type: '虫',
    category: 'physical',
    accuracy: 100,
    energyCost: 7,
    effect: '造成物伤，1连击，本技能会受奉献影响。',
  },
  {
    id: '750',
    name: '虫击',
    power: 90,
    type: '虫',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，应对状态：本次技能威力变为2倍，无视敌方系别抵抗。',
  },
  {
    id: '751',
    name: '翅刃',
    power: 95,
    type: '虫',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '造成物伤，驱散敌方所有印记，应对状态：改为偷取印记。',
  },
  {
    id: '752',
    name: '震击',
    power: 80,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成伤害，敌方获得连击数-3。',
  },
  {
    id: '753',
    name: '鸣沙陷阱',
    power: 60,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '造成物伤，物防比敌方越高，本次技能威力越高。',
  },
  {
    id: '754',
    name: '岩脉崩毁',
    power: 120,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '造成物伤，本技能能耗固定为4。',
  },
  {
    id: '755',
    name: '岩土暴击',
    power: 140,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 8,
    effect: '造成物伤，每被攻击1次。本技能能耗永久-1。',
  },
  {
    id: '756',
    name: '地震',
    power: 190,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 10,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '757',
    name: '抛石',
    power: 140,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 30,
    effect: '造成物伤，回合结束时，本技能能耗永久-5。',
  },
  {
    id: '758',
    name: '裂石',
    power: 95,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，应对状态：敌方获得物防-80%。',
  },
  {
    id: '759',
    name: '地刺',
    power: 90,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，应对状态：额外打断被应对技能。',
  },
  {
    id: '760',
    name: '地陷',
    power: 80,
    type: '地',
    category: 'physical',
    accuracy: 100,
    energyCost: 5,
    effect: '造成物伤，自己获得物防+70%，应对状态：本次技能威力翻倍，且物防额外+70%。',
  },
  {
    id: '761',
    name: '导电撞击',
    power: 40,
    type: '电',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '762',
    name: '超导加速',
    power: 70,
    type: '电',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '造成魔伤，自己获得速度+30。',
  },
  {
    id: '763',
    name: '交叉闪电',
    power: 100,
    type: '电',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '764',
    name: '感电',
    power: 60,
    type: '电',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '造成魔伤，每离场1次，本技能使用次数永久+1。',
  },
  {
    id: '765',
    name: '闪击折返',
    power: 45,
    type: '电',
    category: 'physical',
    accuracy: 100,
    energyCost: 5,
    effect: '造成物伤，2连击，自己脱离。',
  },
  {
    id: '766',
    name: '强制重启',
    power: 90,
    type: '电',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，应对状态：回合结束时使敌方精灵返场。',
  },
  {
    id: '767',
    name: '毒针',
    power: 20,
    type: '毒',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '造成物伤，敌方获得1层中毒。',
  },
  {
    id: '768',
    name: '连续毒针',
    power: 15,
    type: '毒',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '造成物伤，2连击，每次连击使敌方获得1层中毒。',
  },
  {
    id: '769',
    name: '感染病',
    power: 110,
    type: '毒',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '造成魔伤，若击败敌方则将中毒转化为中毒印记。',
  },
  {
    id: '770',
    name: '毒囊',
    power: 25,
    type: '毒',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '造成物伤，敌方获得2层中毒，应对状态：改为获得6层。',
  },
  {
    id: '771',
    name: '鸩毒',
    power: 75,
    type: '毒',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，敌方每有1层中毒效果，本次技能威力+10，应对状态：改为本次威力+20。',
  },
  {
    id: '772',
    name: '迫害',
    power: 40,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '773',
    name: '魔爪',
    power: 30,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '造成物伤，自己回复1能量。',
  },
  {
    id: '774',
    name: '掠夺',
    power: 60,
    type: '恶',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '775',
    name: '撕咬',
    power: 30,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，3连击，若自己的生命低于50%，本次技能连击数+2。',
  },
  {
    id: '776',
    name: '极限撕裂',
    power: 135,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '造成物伤，若生命高于50%，使用后自己获得双攻-50%。',
  },
  {
    id: '777',
    name: '彼岸之手',
    power: 150,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 10,
    effect: '造成物伤，自己每失去10%生命，本技能能耗-1。',
  },
  {
    id: '778',
    name: '撕裂',
    power: 85,
    type: '恶',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，应对状态：本次攻击吸血100%。',
  },
  {
    id: '779',
    name: '折射',
    power: 50,
    type: '光',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '造成魔伤，携带其他系别技能会给本技能带来不同效果。',
  },
  {
    id: '780',
    name: '脉冲光线',
    power: 40,
    type: '光',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '781',
    name: '闪光',
    power: 60,
    type: '光',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '782',
    name: '光刃',
    power: 120,
    type: '光',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '783',
    name: '粒子对撞',
    power: 40,
    type: '幻',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '784',
    name: '大爆炸',
    power: 100,
    type: '幻',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '785',
    name: '多维击打',
    power: 15,
    type: '幻',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '造成魔伤，1连击，敌方每有1层星陨印记，本次技能连击数+1。',
  },
  {
    id: '786',
    name: '四维降解',
    power: 100,
    type: '幻',
    category: 'special',
    accuracy: 100,
    energyCost: 7,
    effect: '造成魔伤，敌方每有1层印记，本技能能耗-1。',
  },
  {
    id: '787',
    name: '错乱',
    power: 65,
    type: '幻',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '造成魔伤，应对状态：敌方获得3层星陨印记。',
  },
  {
    id: '788',
    name: '双响炮',
    power: 25,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '造成物伤，2连击。',
  },
  {
    id: '789',
    name: '吹火',
    power: 50,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '造成物伤，每次使用后，本技能威力永久+20。',
  },
  {
    id: '790',
    name: '火爪',
    power: 60,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '791',
    name: '炎打',
    power: 95,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '造成高额魔法伤害，自己获得物防-40%。',
  },
  {
    id: '792',
    name: '炎枪',
    power: 100,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '793',
    name: '火焰切割',
    power: 100,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '794',
    name: '高温回火',
    power: 40,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '造成魔伤，自己脱离。',
  },
  {
    id: '795',
    name: '山火',
    power: 15,
    type: '火',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，每使用1次其他火系技能，本技能威力永久翻倍。',
  },
  {
    id: '796',
    name: '燃尽',
    power: 155,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '造成魔伤，敌方每失去5%生命，本次技能威力-5。',
  },
  {
    id: '797',
    name: '除厄',
    power: 60,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '造成魔伤，驱散自己的减益。',
  },
  {
    id: '798',
    name: '阳火增辉',
    power: 75,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，每次击败敌方，本技能威力永久翻倍。',
  },
  {
    id: '799',
    name: '炙热波动',
    power: 55,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，敌方获得4层灼烧，应对状态：本次技能威力和赋予灼烧翻倍。',
  },
  {
    id: '800',
    name: '持续高温',
    power: 70,
    type: '火',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '造成魔伤，应对状态：下次攻击技能威力翻倍。',
  },
  {
    id: '801',
    name: '传感器',
    power: 20,
    type: '机械',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '造成物伤，2连击，本技能位于1号或3号位时连击+1，传动1。',
  },
  {
    id: '802',
    name: '钢钻',
    power: 0,
    type: '机械',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '造成物伤，技能威力为两侧技能威力和的三分之一，传动1。',
  },
  {
    id: '803',
    name: '龙吼',
    power: 60,
    type: '龙',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '804',
    name: '绵里藏针',
    power: 60,
    type: '龙',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '造成魔伤，若自己上回合未攻击敌方并造成伤害，本技能威力永久+20。',
  },
  {
    id: '805',
    name: '飞吻',
    power: 80,
    type: '萌',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '806',
    name: '破罐破摔',
    power: 80,
    type: '萌',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，自己有减益时，本次技能威力+60。',
  },
  {
    id: '807',
    name: '月光合奏',
    power: 30,
    type: '萌',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，1连击，双方携带的所有精灵每有1层萌化，本次技能连击数+1。',
  },
  {
    id: '808',
    name: '蓄能轰击',
    power: 130,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 6,
    effect: '造成魔伤，每使用1次普通系技能，本技能能耗永久-2。',
  },
  {
    id: '809',
    name: '扫尾',
    power: 90,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '810',
    name: '迫近攻击',
    power: 90,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤。每次使用后，本技能威力永久+45。',
  },
  {
    id: '811',
    name: '乘胜追击',
    power: 40,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '造成物伤，1连击，每次使用后，本技能连击数永久+1。',
  },
  {
    id: '812',
    name: '逆袭',
    power: 100,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，本技能能耗每+1，威力+50。',
  },
  {
    id: '813',
    name: '重击',
    power: 110,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '造成物伤，每次使用后，本技能能耗永久+1。',
  },
  {
    id: '814',
    name: '后发制人',
    power: 155,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物理伤害，先手-1。',
  },
  {
    id: '815',
    name: '湮灭',
    power: 155,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 5,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '816',
    name: '以重制重',
    power: 0,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，敌方体重越高，本次技能威力越高。',
  },
  {
    id: '817',
    name: '穿膛',
    power: 65,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '造成物伤，若敌方能量小于等于2，造成5倍伤害。',
  },
  {
    id: '818',
    name: '飞踢',
    power: 110,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '819',
    name: '天旋地转',
    power: 60,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物理伤害，先手+1，迸发：本次技能威力+30。',
  },
  {
    id: '820',
    name: '魔能爆',
    power: 1,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '造成魔伤，使用时消耗所有能量，消耗越高，伤害越高。',
  },
  {
    id: '821',
    name: '垂死反击',
    power: 80,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '造成物伤，自己每失去5%生命，本次技能威力+5。',
  },
  {
    id: '822',
    name: '彗星',
    power: 240,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '造成魔伤，每失去5%生命，本次技能威力-10，使用后消耗全部生命。',
  },
  {
    id: '823',
    name: '触底强击',
    power: 95,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '造成魔伤，使用后若能量耗尽，本次技能威力+120。',
  },
  {
    id: '824',
    name: '践踏',
    power: 130,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '825',
    name: '压扁',
    power: 155,
    type: '普通',
    category: 'physical',
    accuracy: 100,
    energyCost: 5,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '826',
    name: '消毒法',
    power: 115,
    type: '普通',
    category: 'special',
    accuracy: 100,
    energyCost: 4,
    effect: '造成魔伤，驱散敌方5层增益。',
  },
  {
    id: '827',
    name: '水弹',
    power: 40,
    type: '水',
    category: 'special',
    accuracy: 100,
    energyCost: 0,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '828',
    name: '肥皂泡',
    power: 60,
    type: '水',
    category: 'special',
    accuracy: 100,
    energyCost: 1,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '829',
    name: '气泡',
    power: 100,
    type: '水',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '830',
    name: '水炮',
    power: 110,
    type: '水',
    category: 'special',
    accuracy: 100,
    energyCost: 5,
    effect: '造成魔伤，每次使用后，本技能能耗永久-1。',
  },
  {
    id: '831',
    name: '涌泉',
    power: 90,
    type: '水',
    category: 'special',
    accuracy: 100,
    energyCost: 6,
    effect: '造成魔伤，本技能能耗每-1，威力+10。',
  },
  {
    id: '832',
    name: '水波术',
    power: 90,
    type: '水',
    category: 'special',
    accuracy: 100,
    energyCost: 6,
    effect: '造成魔伤，回合结束时，本技能威力永久+20。',
  },
  {
    id: '833',
    name: '水刃',
    power: 115,
    type: '水',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '造成物伤，应对状态：本技能能耗永久-3。',
  },
  {
    id: '834',
    name: '天洪',
    power: 150,
    type: '水',
    category: 'special',
    accuracy: 100,
    energyCost: 7,
    effect: '造成魔伤，应对状态：本技能能耗永久-6。',
  },
  {
    id: '835',
    name: '影袭',
    power: 100,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '836',
    name: '爆冲',
    power: 65,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，应对状态：本次技能威力变为5倍。',
  },
  {
    id: '837',
    name: '斩断',
    power: 70,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '造成物伤，应对状态：额外打断被应对技能。',
  },
  {
    id: '838',
    name: '无影脚',
    power: 85,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，应对状态：本次技能威力变为2倍。',
  },
  {
    id: '839',
    name: '技巧打击',
    power: 35,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '造成物伤，应对状态：本次技能威力变为10倍。',
  },
  {
    id: '840',
    name: '散手',
    power: 35,
    type: '武',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，2连击，应对状态：本技能改为6连击。',
  },
  {
    id: '841',
    name: '啄击',
    power: 15,
    type: '翼',
    category: 'physical',
    accuracy: 100,
    energyCost: 0,
    effect: '造成物伤，2连击。',
  },
  {
    id: '842',
    name: '扇风',
    power: 75,
    type: '翼',
    category: 'physical',
    accuracy: 100,
    energyCost: 3,
    effect: '造成物伤，若先于敌方攻击，本次技能威力+50%。',
  },
  {
    id: '843',
    name: '回旋风暴',
    power: 100,
    type: '翼',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '对敌方精灵造成魔法伤害。',
  },
  {
    id: '844',
    name: '闪击',
    power: 60,
    type: '翼',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '造成物伤，速度比敌方越高，本次技能威力越高。',
  },
  {
    id: '845',
    name: '俯冲猛击',
    power: 140,
    type: '翼',
    category: 'physical',
    accuracy: 100,
    energyCost: 5,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '846',
    name: '羽刃',
    power: 75,
    type: '翼',
    category: 'physical',
    accuracy: 100,
    energyCost: 2,
    effect: '造成物伤，应对状态：回合结束使敌方紧急脱离。',
  },
  {
    id: '847',
    name: '坟场搏击',
    power: 180,
    type: '幽',
    category: 'physical',
    accuracy: 100,
    energyCost: 4,
    effect: '造成物伤，敌方每有1能量，本次技能威力-10%。',
  },
  {
    id: '848',
    name: '幻象',
    power: 60,
    type: '幽',
    category: 'physical',
    accuracy: 100,
    energyCost: 1,
    effect: '对敌方精灵造成物理伤害。',
  },
  {
    id: '849',
    name: '灵光',
    power: 25,
    type: '幽',
    category: 'special',
    accuracy: 100,
    energyCost: 3,
    effect: '造成魔伤，3连击，若敌方本回合更换精灵，本次技能连击数翻倍。',
  },
  {
    id: '850',
    name: '背袭',
    power: 40,
    type: '幽',
    category: 'special',
    accuracy: 100,
    energyCost: 2,
    effect: '造成魔伤，若敌方能量等于0，造成20倍伤害。',
  },
];

export const SKILL_MAP: Record<string, Skill> = Object.fromEntries(
  SKILLS.map((s) => [s.id, s]),
);
